export const TasksService = {
  getData() {
    return [
      {
        description: '',

        tasklName: 'Наряд 1',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 1',
        department: {
          label: 'ДРОС',
          key: '3008b6c1-a484-4ce8-a43f-c0ad990dc828'
        },
        employees: [
          {
            fullName: 'Исполнитель1',
            id: 'b512e8fc-e295-4c78-8d28-1251848a21f8'
          },
          {
            fullName: 'Исполнитель1x',
            id: 'b512e8fc-e295-4c78-8d28-1251848a21f81'
          }
        ],
        actualStartDate: '02/24/2024 16:00',
        plannedEndDate: '02/25/2024 16:00',
        actualEndDate: '02/25/2024 16:00',
        priority: 'Низкий',
        id: '2f5fcc59-0c9b-4b6e-87d4-155bec234a9c'
      },
      {
        description: '',

        tasklName: 'Наряд 2',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 2',
        department: {
          label: 'ДРОС',
          key: '77e0c9ce-07b9-47c7-8fca-9c7ca346d05b'
        },
        employees: [
          {
            fullName: 'Исполнитель2',
            id: '3c029fee-0717-4d02-af52-3cbbdb1de7d2'
          },
          {
            fullName: 'Исполнитель1y',
            id: 'b512e8fc-e295-4c78-8d28-1251848a21f8113'
          },
          {
            fullName: 'Исполнитель1y1',
            id: 'b512e8fc-e295-4c78-8d28-1251848a21f8112'
          }
        ],
        actualStartDate: '02/25/2024 16:00',
        plannedEndDate: '02/26/2024 16:00',
        actualEndDate: '02/26/2024 16:00',
        priority: 'Средний',
        id: 'c47ba2f1-7674-47a6-a16d-12a049b850f6'
      },
      {
        description: '',

        tasklName: 'Наряд 3',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 3',
        department: {
          label: 'ДРОС',
          key: 'a92c7767-ee59-41b3-a4d0-b6c83e5370aa'
        },
        employees: [
          {
            fullName: 'Исполнитель3',
            id: '397e8e4a-46aa-43bd-aecd-894054cd1a3f'
          },
          {
            fullName: 'someone 1',
            id: 'b512e8fc-e295-4c78-8d28-1251848a21f81123'
          },
          {
            fullName: 'someone else',
            id: 'b512e8fc-e295-4c78-8d28-1251848a21f81122'
          }
        ],
        actualStartDate: '02/26/2024 16:00',
        plannedEndDate: '02/27/2024 16:00',
        actualEndDate: '02/27/2024 16:00',
        priority: 'Высокий',
        id: '7375cdc5-442b-4ff7-a42a-f72a8c277cd8'
      },
      {
        description: '',

        tasklName: 'Наряд 4',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 4',
        department: {
          label: 'ДРОС',
          key: 'fb0c65e6-e6f3-4144-a71e-ed68b46131c6'
        },
        employees: [
          {
            fullName: 'Исполнитель4',
            id: '1619a218-531d-46ff-b389-59462b7cdda0'
          }
        ],
        actualStartDate: '02/27/2024 16:00',
        plannedEndDate: '02/28/2024 16:00',
        actualEndDate: '02/28/2024 16:00',
        priority: 'Низкий',
        id: 'c62dfe49-0e26-46a5-83de-08ef01cfbd5f'
      },
      {
        description: '',

        tasklName: 'Наряд 5',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 5',
        department: {
          label: 'ДРОС',
          key: 'd8c0b48a-f99a-4a47-a4ee-6db9c4ead9fe'
        },
        employees: [
          {
            fullName: 'Исполнитель5',
            id: '4bbef0ab-b607-4272-88d4-7b0a8e2725e8'
          }
        ],
        actualStartDate: '02/28/2024 16:00',
        plannedEndDate: '02/29/2024 16:00',
        actualEndDate: '02/29/2024 16:00',
        priority: 'Средний',
        id: 'ec719810-66e0-4c47-a921-c3a524f96c05'
      },
      {
        description: '',

        tasklName: 'Наряд 6',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 6',
        department: {
          label: 'ДРОС',
          key: 'c2c295a2-b74a-4642-940e-4ba760e8df61'
        },
        employees: [
          {
            fullName: 'Исполнитель6',
            id: '9a224465-48e0-41f1-bd10-772c7564a491'
          }
        ],
        actualStartDate: '02/29/2024 16:00',
        plannedEndDate: '03/01/2024 16:00',
        actualEndDate: '03/01/2024 16:00',
        priority: 'Высокий',
        id: 'a8ef6d92-7056-46c6-89c4-3f70e2343212'
      },
      {
        description: '',

        tasklName: 'Наряд 7',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 7',
        department: {
          label: 'ДРОС',
          key: '81e3bcf3-d5be-41dc-baae-6ac1ca0b5adc'
        },
        employees: [
          {
            fullName: 'Исполнитель7',
            id: 'f6b48f3c-2ab4-4dfb-9372-1adfc4b8bcbd'
          }
        ],
        actualStartDate: '03/01/2024 16:00',
        plannedEndDate: '03/02/2024 16:00',
        actualEndDate: '03/02/2024 16:00',
        priority: 'Низкий',
        id: 'b127772f-56af-47a8-9aaf-eb5faffcd49d'
      },
      {
        description: '',

        tasklName: 'Наряд 8',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 8',
        department: {
          label: 'НФТС Нумерация и ГОЗ',
          key: '857e0a16-24ff-4269-9a46-8eb1c485c720'
        },
        employees: [
          {
            fullName: 'Исполнитель8',
            id: '283e0d38-bd41-48bf-a290-32b1b6a40f24'
          }
        ],
        actualStartDate: '03/02/2024 16:00',
        plannedEndDate: '03/03/2024 16:00',
        actualEndDate: '03/03/2024 16:00',
        priority: 'Средний',
        id: '571e72d7-15e9-4639-99aa-bcc1ca203228'
      },
      {
        description: '',

        tasklName: 'Наряд 9',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 9',
        department: {
          label: 'НФТС Нумерация и ГОЗ',
          key: 'a912ab16-8537-4cf6-aad3-034e2870c7e9'
        },
        employees: [
          {
            fullName: 'Исполнитель9',
            id: '96fbac84-e89f-439c-9030-dc39ba4349d3'
          }
        ],
        actualStartDate: '03/03/2024 16:00',
        plannedEndDate: '03/04/2024 16:00',
        actualEndDate: '03/04/2024 16:00',
        priority: 'Высокий',
        id: 'd548ebe8-deb8-4f69-b072-6914da8b1b23'
      },
      {
        description: '',

        tasklName: 'Наряд 10',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 10',
        department: {
          label: 'НФТС Нумерация и ГОЗ',
          key: '7d03ec6c-03f5-4d1a-93f7-e9506899b486'
        },
        employees: [
          {
            fullName: 'Исполнитель10',
            id: 'ba799059-a60d-4e0b-820a-6e5f3899d75f'
          }
        ],
        actualStartDate: '03/04/2024 16:00',
        plannedEndDate: '03/05/2024 16:00',
        actualEndDate: '03/05/2024 16:00',
        priority: 'Низкий',
        id: '6371ffff-9be4-41aa-8647-f6ee083ad062'
      },
      {
        description: '',

        tasklName: 'Наряд 11',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 11',
        department: {
          label: 'НФТС Нумерация и ГОЗ',
          key: 'bb132c87-b240-4ab2-8a75-55912decee62'
        },
        employees: [
          {
            fullName: 'Исполнитель11',
            id: 'bb5ba308-5646-46ec-a122-cd1355beb2c5'
          }
        ],
        actualStartDate: '03/05/2024 16:00',
        plannedEndDate: '10/05/2023 10:00',
        actualEndDate: '10/05/2023 10:00',
        priority: 'Средний',
        id: 'b741fdc0-8e24-4e0c-9ca1-413e2e164baa'
      },
      {
        description: '',

        tasklName: 'Наряд 12',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 12',
        department: {
          label: 'НФТС Нумерация и ГОЗ',
          key: '641ca2ce-b83e-4208-9ea1-b5708c319ff5'
        },
        employees: [
          {
            fullName: 'Исполнитель12',
            id: 'c521eae1-a0eb-4769-87fd-3729ea098158'
          }
        ],
        actualStartDate: '10/05/2023 10:00',
        plannedEndDate: '10/06/2023 10:00',
        actualEndDate: '10/06/2023 10:00',
        priority: 'Высокий',
        id: '266a7cee-e235-41e2-b918-668edc1aca03'
      },
      {
        description: '',

        tasklName: 'Наряд 13',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 13',
        department: {
          label: 'НФТС Нумерация и ГОЗ',
          key: 'f7960598-b5ac-415b-86eb-6849379c9dd7'
        },
        employees: [
          {
            fullName: 'Исполнитель13',
            id: 'b9847c63-712d-4073-8e83-23898822421e'
          },
          {
            fullName: 'anyone 1',
            id: 'b512e8fc-e295-4c78-8d28-1251848ab512e8fc'
          },
          {
            fullName: 'anyone else',
            id: 'b512e8fc-e295-4c78-8d28-b512e8fc81122'
          }
        ],
        actualStartDate: '10/06/2023 10:00',
        plannedEndDate: '10/07/2023 10:00',
        actualEndDate: '10/07/2023 10:00',
        priority: 'Низкий',
        id: '3375ed4e-1fed-4570-8432-5f4fb4c542ba'
      },
      {
        description: '',

        tasklName: 'Наряд 14',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 14',
        department: {
          label: 'ПРСГП',
          key: 'e3abd15c-2084-4635-baf6-44b04515f7ac'
        },
        employees: [
          {
            fullName: 'Исполнитель14',
            id: 'f21935d9-b521-4f54-83d4-b4441a21af86'
          }
        ],
        actualStartDate: '10/07/2023 10:00',
        plannedEndDate: '10/08/2023 10:00',
        actualEndDate: '10/08/2023 10:00',
        priority: 'Средний',
        id: 'de4b964b-9161-4800-8af1-8704e4f36473'
      },
      {
        description: '',

        tasklName: 'Наряд 15',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 15',
        department: {
          label: 'ДУВС',
          key: 'b14ea30c-6844-4039-8169-e87d86accfde'
        },
        employees: [
          {
            fullName: 'Исполнитель15',
            id: '48c1ecaa-8b6e-4a37-8641-895a51d02464'
          }
        ],
        actualStartDate: '10/08/2023 10:00',
        plannedEndDate: '10/09/2023 10:00',
        actualEndDate: '10/09/2023 10:00',
        priority: 'Высокий',
        id: '8417b8ec-9c9c-4a90-a398-a200bff1bbe0'
      },
      {
        description: '',

        tasklName: 'Наряд 16',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 16',
        department: {
          label: 'НФТС УФС',
          key: '473f6d35-fbcb-46ec-b1ba-8452013d36ad'
        },
        employees: [
          {
            fullName: 'Исполнитель16',
            id: '6ef6d3ce-52a5-4796-bd7e-292fe9979064'
          }
        ],
        actualStartDate: '10/09/2023 10:00',
        plannedEndDate: '10/10/2023 10:00',
        actualEndDate: '10/10/2023 10:00',
        priority: 'Низкий',
        id: 'ecd58a16-1820-4e32-bc0e-7e3e62a9258f'
      },
      {
        description: '',

        tasklName: 'Наряд 17',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 17',
        department: {
          label: 'ДРОС',
          key: '01023f05-dfe1-4e5a-b548-f26fc5d67ebb'
        },
        employees: [
          {
            fullName: 'Исполнитель17',
            id: '45937808-72d8-47cb-9d4b-693859d0f072'
          }
        ],
        actualStartDate: '10/10/2023 10:00',
        plannedEndDate: '10/11/2023 10:00',
        actualEndDate: '10/11/2023 10:00',
        priority: 'Средний',
        id: 'd4090ea7-e47a-40c7-9f6b-24d7996cfb8b'
      },
      {
        description: '',

        tasklName: 'Наряд 18',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 18',
        department: {
          label: ' ДИИГС',
          key: '7d068516-5fbe-4d47-a9d0-52f6fcda9dce'
        },
        employees: [
          {
            fullName: 'Исполнитель18',
            id: '1e3fe7a6-ed4a-4e04-8e91-349cbecac716'
          }
        ],
        actualStartDate: '10/11/2023 10:00',
        plannedEndDate: '10/12/2023 10:00',
        actualEndDate: '10/12/2023 10:00',
        priority: 'Высокий',
        id: '8b3e94ed-321a-445a-a864-d55d12cd9439'
      },
      {
        description: '',

        tasklName: 'Наряд 19',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 19',
        department: {
          label: 'НМТС Запад СГМД',
          key: 'c6bf9830-5711-4238-b211-cf65d3ed1f50'
        },
        employees: [
          {
            fullName: 'Исполнитель19',
            id: 'ed0e863f-dee8-4fbc-a5e5-aa5beec68720'
          }
        ],
        actualStartDate: '10/12/2023 10:00',
        plannedEndDate: '10/13/2023 10:00',
        actualEndDate: '10/13/2023 10:00',
        priority: 'Низкий',
        id: 'df7055d2-703c-4ecd-a724-684886889d29'
      },
      {
        description: '',

        tasklName: 'Наряд 20',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 20',
        department: {
          label: 'Опер.Дежурный',
          key: '66041614-32f0-4183-9e36-b8638c74860b'
        },
        employees: [
          {
            fullName: 'Исполнитель20',
            id: 'e46d3301-017e-4018-ad15-438c184bf190'
          }
        ],
        actualStartDate: '10/13/2023 10:00',
        plannedEndDate: '10/14/2023 10:00',
        actualEndDate: '10/14/2023 10:00',
        priority: 'Средний',
        id: 'af2414ce-1b90-4df0-80af-07a98045c8f3'
      },
      {
        description: '',

        tasklName: 'Наряд 21',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 21',
        department: {
          label: 'НМТС Восток',
          key: '86728e2d-3f14-442d-a458-db990f2e8c5d'
        },
        employees: [
          {
            fullName: 'Исполнитель21',
            id: 'c90cd59d-3098-4b59-bbd6-44bb42c9bdcc'
          }
        ],
        actualStartDate: '10/14/2023 10:00',
        plannedEndDate: '10/15/2023 10:00',
        actualEndDate: '10/15/2023 10:00',
        priority: 'Высокий',
        id: '4eaec6b1-cf22-434b-b6c3-092506bf7026'
      },
      {
        description: '',

        tasklName: 'Наряд 22',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 22',
        department: {
          label: 'ТЦКПМТ МРФ Центр',
          key: '7bfb2a59-9b7e-4cb8-b4d6-7dac386d599f'
        },
        employees: [
          {
            fullName: 'Исполнитель22',
            id: '283dbd91-09ed-47c3-8d68-3a32162366bd'
          }
        ],
        actualStartDate: '10/15/2023 10:00',
        plannedEndDate: '10/16/2023 10:00',
        actualEndDate: '10/16/2023 10:00',
        priority: 'Низкий',
        id: '5be3c703-427d-4d25-af36-38bb43735d26'
      },
      {
        description: '',

        tasklName: 'Наряд 23',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 23',
        department: {
          label: 'НПСиТС ПС',
          key: '9dca64b0-f693-4f54-bdd1-d37042a8e8c8'
        },
        employees: [
          {
            fullName: 'Исполнитель23',
            id: '13a79954-d5d2-4ef6-9d43-738c6af5b11a'
          }
        ],
        actualStartDate: '10/16/2023 10:00',
        plannedEndDate: '10/17/2023 10:00',
        actualEndDate: '10/17/2023 10:00',
        priority: 'Средний',
        id: 'f9ee2b2b-9ad4-49f4-bccc-41a5eafbf0ad'
      },
      {
        description: '',

        tasklName: 'Наряд 24',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 24',
        department: {
          label: 'ДРС',
          key: '525be529-7201-4058-98bd-5e527186091c'
        },
        employees: [
          {
            fullName: 'Исполнитель24',
            id: '1cc32406-2b27-4b13-9892-61c37dfe7ee7'
          }
        ],
        actualStartDate: '10/17/2023 10:00',
        plannedEndDate: '10/18/2023 10:00',
        actualEndDate: '10/18/2023 10:00',
        priority: 'Высокий',
        id: '709d18d8-01da-4477-90c7-af7972e5c5e5'
      },
      {
        description: '',

        tasklName: 'Наряд 25',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 25',
        department: {
          label: 'ОПИГИС',
          key: '46194b28-966e-46b3-9ef3-77bce3abc78a'
        },
        employees: [
          {
            fullName: 'Исполнитель25',
            id: 'ad405858-18a2-4183-a642-30fa88ac9bd2'
          }
        ],
        actualStartDate: '10/18/2023 10:00',
        plannedEndDate: '10/19/2023 10:00',
        actualEndDate: '10/19/2023 10:00',
        priority: 'Низкий',
        id: '0e8e874f-0e59-4ef9-b176-617925441246'
      },
      {
        description: '',

        tasklName: 'Наряд 26',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 26',
        department: {
          label: 'ОПМС ДПС',
          key: '0f5ca379-de33-446c-9806-6f3c2b033375'
        },
        employees: [
          {
            fullName: 'Исполнитель26',
            id: '1f523152-b5da-4fe4-b46f-fc7d982f5eb3'
          }
        ],
        actualStartDate: '10/19/2023 10:00',
        plannedEndDate: '10/20/2023 10:00',
        actualEndDate: '10/20/2023 10:00',
        priority: 'Средний',
        id: '51f8ea82-f013-4a2e-87eb-cfe781b8cf44'
      },
      {
        description: '',

        tasklName: 'Наряд 27',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 27',
        department: {
          label: 'НПСиТС ТЛГ',
          key: '381c51b8-fd72-4d30-aa52-4d2a1ddc3bb9'
        },
        employees: [
          {
            fullName: 'Исполнитель27',
            id: 'a372289b-0373-4fc8-9572-20100883c4c9'
          }
        ],
        actualStartDate: '10/20/2023 10:00',
        plannedEndDate: '10/21/2023 10:00',
        actualEndDate: '10/21/2023 10:00',
        priority: 'Высокий',
        id: 'df6f0a1f-94d7-4647-89b5-9dbcbad8289d'
      },
      {
        description: '',

        tasklName: 'Наряд 28',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 28',
        department: {
          label: 'ОАФУIPССКП ДАФУ',
          key: '36f3a516-5b1e-4398-9b34-b35ebaf4d74c'
        },
        employees: [
          {
            fullName: 'Исполнитель28',
            id: 'd211a701-076b-4297-8d4a-752ee918875a'
          }
        ],
        actualStartDate: '10/21/2023 10:00',
        plannedEndDate: '10/22/2023 10:00',
        actualEndDate: '10/22/2023 10:00',
        priority: 'Низкий',
        id: '2d2b0db6-f356-4699-911c-ec5cf9ecd141'
      },
      {
        description: '',

        tasklName: 'Наряд 29',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 29',
        department: {
          label: 'НФСК ОКС7',
          key: '45bf9abe-cd25-41d7-8f57-18ea5d9dc9a1'
        },
        employees: [
          {
            fullName: 'Исполнитель29',
            id: '051ded46-94ea-4256-9f41-93b2d970903a'
          }
        ],
        actualStartDate: '10/22/2023 10:00',
        plannedEndDate: '10/23/2023 10:00',
        actualEndDate: '10/23/2023 10:00',
        priority: 'Средний',
        id: '546abde4-c400-4824-a943-1e2e6d34820c'
      },
      {
        description: '',

        tasklName: 'Наряд 30',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 30',
        department: {
          label: 'Блок МВ',
          key: '7e6d48c1-c7a4-45bc-80cd-919429d25d28'
        },
        employees: [
          {
            fullName: 'Исполнитель30',
            id: '449f3a0a-4cd7-40d3-a520-c3374e1a1002'
          }
        ],
        actualStartDate: '10/23/2023 10:00',
        plannedEndDate: '10/24/2023 10:00',
        actualEndDate: '10/24/2023 10:00',
        priority: 'Высокий',
        id: '213fc1cd-88d2-4349-b951-eaba45e8772e'
      },
      {
        description: '',

        tasklName: 'Наряд 31',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 31',
        department: {
          label: 'НМТС Запад',
          key: '5ac7aceb-45e8-4e59-9d6f-e8055b53eae6'
        },
        employees: [
          {
            fullName: 'Исполнитель31',
            id: '41722b31-1eaf-4383-9c62-7e98242ebe55'
          }
        ],
        actualStartDate: '10/24/2023 10:00',
        plannedEndDate: '10/25/2023 10:00',
        actualEndDate: '10/25/2023 10:00',
        priority: 'Низкий',
        id: '035721fe-dfed-4fbc-a29c-397bb85a48e0'
      },
      {
        description: '',

        tasklName: 'Наряд 32',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 32',
        department: {
          label: 'ОАТС ДАСС',
          key: '22028b7c-2d4e-428c-ad75-7a9e762100d1'
        },
        employees: [
          {
            fullName: 'Исполнитель32',
            id: '4a1b0e13-7305-4d35-b37d-40a6d70071b6'
          }
        ],
        actualStartDate: '10/25/2023 10:00',
        plannedEndDate: '10/26/2023 10:00',
        actualEndDate: '10/26/2023 10:00',
        priority: 'Средний',
        id: 'dcecb116-eb93-4933-b295-25e9b6de23f9'
      },
      {
        description: '',

        tasklName: 'Наряд 33',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 33',
        department: {
          label: 'НМТС Запад СГМД Смена',
          key: '9ca2b65c-4ff6-4bb5-a487-941904d6a540'
        },
        employees: [
          {
            fullName: 'Исполнитель33',
            id: '7a7ea764-20ab-434a-8a87-3a10c88406a2'
          }
        ],
        actualStartDate: '10/26/2023 10:00',
        plannedEndDate: '02/24/2024 16:00',
        actualEndDate: '02/24/2024 16:00',
        priority: 'Высокий',
        id: 'ef5e84fa-da86-4d22-ae59-0533be252dd9'
      },
      {
        description: '',

        tasklName: 'Наряд 34',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 34',
        department: {
          label: 'Оренбургский филиал',
          key: 'ac7d2d9d-59d0-4de4-9965-d3e50ee85f79'
        },
        employees: [
          {
            fullName: 'Исполнитель34',
            id: '67f90259-ebce-4002-8281-b13270c63ed9'
          }
        ],
        actualStartDate: '02/24/2024 16:00',
        plannedEndDate: '02/25/2024 16:00',
        actualEndDate: '02/25/2024 16:00',
        priority: 'Низкий',
        id: 'e93120fc-7c1e-4f7a-975c-44e789d8685b'
      },
      {
        description: '',

        tasklName: 'Наряд 35',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 35',
        department: {
          label: 'Филиал в республике Татарстан',
          key: '0ad0315f-6c71-42cc-9af2-4f7cb765e443'
        },
        employees: [
          {
            fullName: 'Исполнитель35',
            id: '37442766-117e-463b-9f43-dd1ecdf386ce'
          }
        ],
        actualStartDate: '02/25/2024 16:00',
        plannedEndDate: '02/26/2024 16:00',
        actualEndDate: '02/26/2024 16:00',
        priority: 'Средний',
        id: 'ec22c084-dd50-4a31-9a79-38ad059d2e9b'
      },
      {
        description: '',

        tasklName: 'Наряд 36',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 36',
        department: {
          label: 'Самарский филиал',
          key: 'f815ce30-3368-42f3-9594-d13cfc4c7bdf'
        },
        employees: [
          {
            fullName: 'Исполнитель36',
            id: '54c5616e-e27c-4c7f-8cce-18c66c10cd6f'
          }
        ],
        actualStartDate: '02/26/2024 16:00',
        plannedEndDate: '02/27/2024 16:00',
        actualEndDate: '02/27/2024 16:00',
        priority: 'Высокий',
        id: '890fe628-e8cf-4221-af96-f5f7bc9a50dc'
      },
      {
        description: '',

        tasklName: 'Наряд 37',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 37',
        department: {
          label: 'Инвентарная СУРТС',
          key: 'd4027f65-18ae-42c9-8d79-435af5a846e6'
        },
        employees: [
          {
            fullName: 'Исполнитель37',
            id: '09b3b777-1ef5-4888-b0f9-95d8973ee7fa'
          }
        ],
        actualStartDate: '02/27/2024 16:00',
        plannedEndDate: '02/28/2024 16:00',
        actualEndDate: '02/28/2024 16:00',
        priority: 'Низкий',
        id: '4174ab61-e3e7-4caa-93e9-03fda193b359'
      },
      {
        description: '',

        tasklName: 'Наряд 38',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 38',
        department: {
          label: 'НТМиРС_Серебренников ВВ',
          key: '00a18f4e-b097-4cc3-ba13-c352a80817de'
        },
        employees: [
          {
            fullName: 'Исполнитель38',
            id: '9c309dd8-ec12-4e54-9d6c-93cfa8dd8fe9'
          }
        ],
        actualStartDate: '02/28/2024 16:00',
        plannedEndDate: '02/29/2024 16:00',
        actualEndDate: '02/29/2024 16:00',
        priority: 'Средний',
        id: 'cf3c54f9-1e90-4a5b-b488-3b0d598fbdc3'
      },
      {
        description: '',

        tasklName: 'Наряд 39',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 39',
        department: {
          label: 'МордовияРФ',
          key: 'f237fe51-49ab-4fc9-bfef-cfd3e84d8a18'
        },
        employees: [
          {
            fullName: 'Исполнитель39',
            id: 'dabf4726-0bec-4bff-ac4e-8eefaac0cf50'
          }
        ],
        actualStartDate: '02/29/2024 16:00',
        plannedEndDate: '03/01/2024 16:00',
        actualEndDate: '03/01/2024 16:00',
        priority: 'Высокий',
        id: 'b1e00559-48b6-464f-a319-b8d980ea90d0'
      },
      {
        description: '',

        tasklName: 'Наряд 40',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 40',
        department: {
          label: 'Пензенский филиал',
          key: '2b124998-74c2-405c-bc46-a91e59bccdf7'
        },
        employees: [
          {
            fullName: 'Исполнитель40',
            id: '24ccfae5-e62f-4d6b-a73f-6cc7596f0521'
          }
        ],
        actualStartDate: '03/01/2024 16:00',
        plannedEndDate: '03/02/2024 16:00',
        actualEndDate: '03/02/2024 16:00',
        priority: 'Низкий',
        id: '4776f302-d317-49e8-92ba-418d962e6e49'
      },
      {
        description: '',

        tasklName: 'Наряд 41',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 41',
        department: {
          label: 'НТМиРС_Старков ВА',
          key: '2b965949-3ad5-4a1b-aaaf-85baadc0dc0e'
        },
        employees: [
          {
            fullName: 'Исполнитель41',
            id: '7f039b8f-b4c5-43e7-a747-d90f9014c6b7'
          }
        ],
        actualStartDate: '03/02/2024 16:00',
        plannedEndDate: '03/03/2024 16:00',
        actualEndDate: '03/03/2024 16:00',
        priority: 'Средний',
        id: 'fd3c4001-4669-42a0-ade7-2513cd3db23b'
      },
      {
        description: '',

        tasklName: 'Наряд 42',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 42',
        department: {
          label: 'НТМиРС_Куракин МС',
          key: 'c6b43b97-c2c1-4e58-bbb4-612edf72de1d'
        },
        employees: [
          {
            fullName: 'Исполнитель42',
            id: 'b5cf2444-74a1-442d-9f0a-ada03fb6d107'
          }
        ],
        actualStartDate: '03/03/2024 16:00',
        plannedEndDate: '03/04/2024 16:00',
        actualEndDate: '03/04/2024 16:00',
        priority: 'Высокий',
        id: '742ee2b4-e7b4-4b3e-9f8c-839ecf33e2ec'
      },
      {
        description: '',

        tasklName: 'Наряд 43',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 43',
        department: {
          label: 'Кировский филиал',
          key: '734cb2b6-5879-4354-97f1-f583532dd244'
        },
        employees: [
          {
            fullName: 'Исполнитель43',
            id: '64d93521-483b-483d-8ffd-55215346a44d'
          }
        ],
        actualStartDate: '03/04/2024 16:00',
        plannedEndDate: '03/05/2024 16:00',
        actualEndDate: '03/05/2024 16:00',
        priority: 'Низкий',
        id: '598ab2c2-192d-4367-9091-9ea3c252045c'
      },
      {
        description: '',

        tasklName: 'Наряд 44',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 44',
        department: {
          label: 'НТМиРС_Орлов ДВ',
          key: 'c890dffb-2454-417e-a3b8-5da15af7017f'
        },
        employees: [
          {
            fullName: 'Исполнитель44',
            id: '4483a065-94e6-4f4d-90e2-be34a884246e'
          }
        ],
        actualStartDate: '03/05/2024 16:00',
        plannedEndDate: '10/05/2023 10:00',
        actualEndDate: '10/05/2023 10:00',
        priority: 'Средний',
        id: '7a0824b8-c2b1-4d89-af4a-da0a7aa74ed4'
      },
      {
        description: '',

        tasklName: 'Наряд 45',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 45',
        department: {
          label: 'ГУТС (МРФ Волга)',
          key: '99bd02b3-ecb9-42da-afcb-6a4269cf25de'
        },
        employees: [
          {
            fullName: 'Исполнитель45',
            id: '96cb8569-c7cb-4f0e-a6be-615ab4995809'
          }
        ],
        actualStartDate: '10/05/2023 10:00',
        plannedEndDate: '10/06/2023 10:00',
        actualEndDate: '10/06/2023 10:00',
        priority: 'Высокий',
        id: '85a29f53-30f8-4a11-b1b1-e5035b3cf8bf'
      },
      {
        description: '',

        tasklName: 'Наряд 46',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 46',
        department: {
          label: 'НТМиРС_Махмудов РМ',
          key: 'edc72222-e6ed-420b-a9fc-ab5e2d416e69'
        },
        employees: [
          {
            fullName: 'Исполнитель46',
            id: 'c568276f-be43-437c-98de-7a665bbea1d4'
          }
        ],
        actualStartDate: '10/06/2023 10:00',
        plannedEndDate: '10/07/2023 10:00',
        actualEndDate: '10/07/2023 10:00',
        priority: 'Низкий',
        id: '917deacb-65fe-4ac0-b1bf-54c1ea46b66c'
      },
      {
        description: '',

        tasklName: 'Наряд 47',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 47',
        department: {
          label: 'НТМиРС_Абрамова НВ',
          key: '98db08fd-d5c6-4e43-8dbc-bb9405c4d13d'
        },
        employees: [
          {
            fullName: 'Исполнитель47',
            id: 'ca594aa4-e668-45f4-a852-c75391c2fc09'
          }
        ],
        actualStartDate: '10/07/2023 10:00',
        plannedEndDate: '10/08/2023 10:00',
        actualEndDate: '10/08/2023 10:00',
        priority: 'Средний',
        id: '23663ca2-16ed-4388-843c-ddc907a6483d'
      },
      {
        description: '',

        tasklName: 'Наряд 48',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 48',
        department: {
          label: 'НТМиРС_Бойцов АО',
          key: 'fda58cb5-b858-4242-a936-2779c660a863'
        },
        employees: [
          {
            fullName: 'Исполнитель48',
            id: 'dda32b6b-0c28-4e03-960e-07829673693f'
          }
        ],
        actualStartDate: '10/08/2023 10:00',
        plannedEndDate: '10/09/2023 10:00',
        actualEndDate: '10/09/2023 10:00',
        priority: 'Высокий',
        id: '66bccf61-8bed-4121-b689-9ab88947f10e'
      },
      {
        description: '',

        tasklName: 'Наряд 49',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 49',
        department: {
          label: 'Схемы (МРФ Волга)',
          key: 'a23ba45f-66fb-4a0b-a5f4-8dab826d8b23'
        },
        employees: [
          {
            fullName: 'Исполнитель49',
            id: 'bc01bdfa-7e28-4c07-a8c8-66aeee562962'
          }
        ],
        actualStartDate: '10/09/2023 10:00',
        plannedEndDate: '10/10/2023 10:00',
        actualEndDate: '10/10/2023 10:00',
        priority: 'Низкий',
        id: '3db3b468-79e1-4bcd-8a9c-9cf39f2bc0a2'
      },
      {
        description: '',

        tasklName: 'Наряд 50',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 50',
        department: {
          label: 'ОАУиФС ЦБД',
          key: 'b5bde513-efbb-41c3-a9b5-7ab5bbb6631e'
        },
        employees: [
          {
            fullName: 'Исполнитель50',
            id: 'ad110b4f-c1fb-4034-920a-042a20fba9a1'
          }
        ],
        actualStartDate: '10/10/2023 10:00',
        plannedEndDate: '10/11/2023 10:00',
        actualEndDate: '10/11/2023 10:00',
        priority: 'Средний',
        id: '2d911044-84e8-49af-a916-9a2e69145478'
      },
      {
        description: '',

        tasklName: 'Наряд 51',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 51',
        department: {
          label: 'НТМиРС_Семёнов СИ',
          key: 'e16dfc21-4ddc-45a6-861d-072bb25e700b'
        },
        employees: [
          {
            fullName: 'Исполнитель51',
            id: 'ec9aa497-31be-4c23-973f-ba0398e3d455'
          }
        ],
        actualStartDate: '10/11/2023 10:00',
        plannedEndDate: '10/12/2023 10:00',
        actualEndDate: '10/12/2023 10:00',
        priority: 'Высокий',
        id: '1abe1557-520a-44a3-90d8-a5c23b6e4cd5'
      },
      {
        description: '',

        tasklName: 'Наряд 52',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 52',
        department: {
          label: 'НТМиРС_Максумов АР',
          key: '254112c8-a12e-42b8-b131-aae6b8e26993'
        },
        employees: [
          {
            fullName: 'Исполнитель52',
            id: '59e8a4f0-c3a8-4142-bd19-d3b8a9893242'
          }
        ],
        actualStartDate: '10/12/2023 10:00',
        plannedEndDate: '10/13/2023 10:00',
        actualEndDate: '10/13/2023 10:00',
        priority: 'Низкий',
        id: '6cc83e6e-d2ba-4a82-af6c-a467eee2cd50'
      },
      {
        description: '',

        tasklName: 'Наряд 53',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 53',
        department: {
          label: 'НТМиРС_Самойлов ЕК',
          key: '53a5b449-0a9a-498f-96fb-1ae28afe783d'
        },
        employees: [
          {
            fullName: 'Исполнитель53',
            id: 'b6e36b37-8877-4fb3-8116-fd5a09b96486'
          }
        ],
        actualStartDate: '10/13/2023 10:00',
        plannedEndDate: '10/14/2023 10:00',
        actualEndDate: '10/14/2023 10:00',
        priority: 'Средний',
        id: 'e4ea02f7-f8fd-4798-b1f5-da1bca67de4e'
      },
      {
        description: '',

        tasklName: 'Наряд 54',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 54',
        department: {
          label: 'НТМиРС_Григорьева РБ',
          key: '896b5e8a-da89-4529-bb82-70657a636aef'
        },
        employees: [
          {
            fullName: 'Исполнитель54',
            id: '7add5efb-39ce-4618-ad53-7252bb5f2e00'
          }
        ],
        actualStartDate: '10/14/2023 10:00',
        plannedEndDate: '10/15/2023 10:00',
        actualEndDate: '10/15/2023 10:00',
        priority: 'Высокий',
        id: 'a7d318d5-ec4d-42ee-accf-924beea9a18d'
      },
      {
        description: '',

        tasklName: 'Наряд 55',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 55',
        department: {
          label: 'НТМиРС_Зубов АВ',
          key: 'c612bd02-166e-4b32-9217-33124a987658'
        },
        employees: [
          {
            fullName: 'Исполнитель55',
            id: '5f81a841-50a0-49e8-b587-602374038353'
          }
        ],
        actualStartDate: '10/15/2023 10:00',
        plannedEndDate: '10/16/2023 10:00',
        actualEndDate: '10/16/2023 10:00',
        priority: 'Низкий',
        id: 'c36eb013-9fe2-4e59-b22d-842797aeebdb'
      },
      {
        description: '',

        tasklName: 'Наряд 56',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 56',
        department: {
          label: 'НТМиРС_Гильмутдинов РР',
          key: '6d52be33-c4f7-4b69-909f-55c80aa55d19'
        },
        employees: [
          {
            fullName: 'Исполнитель56',
            id: 'bb5f8434-2a43-4776-a557-58c22123a0f7'
          }
        ],
        actualStartDate: '10/16/2023 10:00',
        plannedEndDate: '10/17/2023 10:00',
        actualEndDate: '10/17/2023 10:00',
        priority: 'Средний',
        id: '2050bb39-f0c1-4f87-9c9a-0d8e3866c525'
      },
      {
        description: '',

        tasklName: 'Наряд 57',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 57',
        department: {
          label: 'Фил Ульяновский',
          key: '957d8240-3a69-4c9c-9091-c06185ce6997'
        },
        employees: [
          {
            fullName: 'Исполнитель57',
            id: 'bc5c86c4-ff5e-4721-88ad-5f5eee716943'
          }
        ],
        actualStartDate: '10/17/2023 10:00',
        plannedEndDate: '10/18/2023 10:00',
        actualEndDate: '10/18/2023 10:00',
        priority: 'Высокий',
        id: '14501eb8-84c6-47bb-af37-02bd0bd8f9f2'
      },
      {
        description: '',

        tasklName: 'Наряд 58',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 58',
        department: {
          label: 'НТМиРС_Мухамадиев ЗР',
          key: '28050879-5f08-4388-ac74-fccc3141a28b'
        },
        employees: [
          {
            fullName: 'Исполнитель58',
            id: '8fdd244f-76b8-48c0-8bee-1e7a1d326116'
          }
        ],
        actualStartDate: '10/18/2023 10:00',
        plannedEndDate: '10/19/2023 10:00',
        actualEndDate: '10/19/2023 10:00',
        priority: 'Низкий',
        id: 'dcfcf2d5-d96b-4aec-a41a-8882e2c1201a'
      },
      {
        description: '',

        tasklName: 'Наряд 59',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 59',
        department: {
          label: 'НТМиРС_Коннов ПА',
          key: '0fdc70db-0307-4816-a60a-4e6ca9e56f6b'
        },
        employees: [
          {
            fullName: 'Исполнитель59',
            id: 'af7e41cb-8013-4190-8e05-4bc01575d4b7'
          }
        ],
        actualStartDate: '10/19/2023 10:00',
        plannedEndDate: '10/20/2023 10:00',
        actualEndDate: '10/20/2023 10:00',
        priority: 'Средний',
        id: '247d57c8-c381-4eb7-bc6b-8ce4927d8d63'
      },
      {
        description: '',

        tasklName: 'Наряд 60',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 60',
        department: {
          label: 'НТМиРС_Свечкова',
          key: 'ca8dffb8-4a50-4abf-a7a0-100a58f0d2cd'
        },
        employees: [
          {
            fullName: 'Исполнитель60',
            id: '013d76d2-1aaa-4dae-a3fd-0ce354df7a69'
          }
        ],
        actualStartDate: '10/20/2023 10:00',
        plannedEndDate: '10/21/2023 10:00',
        actualEndDate: '10/21/2023 10:00',
        priority: 'Высокий',
        id: 'd648c321-0576-4bdb-a77c-4719fe3fef37'
      },
      {
        description: '',

        tasklName: 'Наряд 61',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 61',
        department: {
          label: 'Фил Магаданский',
          key: '738b822e-d681-4496-94a7-7e486ae4cd43'
        },
        employees: [
          {
            fullName: 'Исполнитель61',
            id: 'dc066705-6730-4c06-9469-6dcd25716098'
          }
        ],
        actualStartDate: '10/21/2023 10:00',
        plannedEndDate: '10/22/2023 10:00',
        actualEndDate: '10/22/2023 10:00',
        priority: 'Низкий',
        id: '71f24ac7-c0d2-4463-91ba-3e16fad7e4e2'
      },
      {
        description: '',

        tasklName: 'Наряд 62',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 62',
        department: {
          label: 'Фил Сахалинский',
          key: '6773052b-eb60-4b64-a53b-3871bfecee82'
        },
        employees: [
          {
            fullName: 'Исполнитель62',
            id: 'b9aeabab-19a0-47a4-9a63-b33774b74806'
          }
        ],
        actualStartDate: '10/22/2023 10:00',
        plannedEndDate: '10/23/2023 10:00',
        actualEndDate: '10/23/2023 10:00',
        priority: 'Средний',
        id: '8b40bd32-46b2-4738-8656-3c77f124473a'
      },
      {
        description: '',

        tasklName: 'Наряд 63',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 63',
        department: {
          label: 'Фил Хабаровский',
          key: 'e5dfce91-ab3c-4f37-bc16-817a71af6394'
        },
        employees: [
          {
            fullName: 'Исполнитель63',
            id: 'e1f198ba-b63b-4237-9d9b-c27a0fc2b365'
          }
        ],
        actualStartDate: '10/23/2023 10:00',
        plannedEndDate: '10/24/2023 10:00',
        actualEndDate: '10/24/2023 10:00',
        priority: 'Высокий',
        id: '8877a7b8-0660-4c5d-899d-a92f0b71611a'
      },
      {
        description: '',

        tasklName: 'Наряд 64',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 64',
        department: {
          label: 'Фил Приморский',
          key: 'efa4f55a-e6a8-4472-8e82-04384d981a3f'
        },
        employees: [
          {
            fullName: 'Исполнитель64',
            id: '01f27184-3cf6-4baa-b455-aecdde4b6c9b'
          }
        ],
        actualStartDate: '10/24/2023 10:00',
        plannedEndDate: '10/25/2023 10:00',
        actualEndDate: '10/25/2023 10:00',
        priority: 'Низкий',
        id: '542921ff-39df-4206-8665-7c84fe75688a'
      },
      {
        description: '',

        tasklName: 'Наряд 65',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 65',
        department: {
          label: 'Фил Сахателеком',
          key: '2df54027-130d-4238-9768-4d80f4923df1'
        },
        employees: [
          {
            fullName: 'Исполнитель65',
            id: 'a8561425-0283-49a5-b6b7-df721cf52cad'
          }
        ],
        actualStartDate: '10/25/2023 10:00',
        plannedEndDate: '10/26/2023 10:00',
        actualEndDate: '10/26/2023 10:00',
        priority: 'Средний',
        id: 'bc770945-dfe1-47d0-a58a-c9370d508caa'
      },
      {
        description: '',

        tasklName: 'Наряд 66',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 66',
        department: {
          label: 'Фил Камчатский',
          key: 'f6403133-3302-4844-87a5-5921c01baec7'
        },
        employees: [
          {
            fullName: 'Исполнитель66',
            id: '90d0abfb-cef1-4159-b286-d3560b636e57'
          }
        ],
        actualStartDate: '10/26/2023 10:00',
        plannedEndDate: '02/24/2024 16:00',
        actualEndDate: '02/24/2024 16:00',
        priority: 'Высокий',
        id: 'f2556a9e-2ee8-4531-a779-cdada50a7c81'
      },
      {
        description: '',

        tasklName: 'Наряд 67',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 67',
        department: {
          label: 'ДРОС ДВ',
          key: '43eb02ef-f4e5-447e-ab01-be4857d8df29'
        },
        employees: [
          {
            fullName: 'Исполнитель67',
            id: '242b7d92-bdda-482a-83c4-22a844b24f00'
          }
        ],
        actualStartDate: '02/24/2024 16:00',
        plannedEndDate: '02/25/2024 16:00',
        actualEndDate: '02/25/2024 16:00',
        priority: 'Низкий',
        id: '1b3976c6-b448-45d5-b4fc-decb270e3d34'
      },
      {
        description: '',

        tasklName: 'Наряд 68',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 68',
        department: {
          label: 'НТМиРС_Ревенок',
          key: '6c15acae-43aa-47f1-b604-a68e1568756f'
        },
        employees: [
          {
            fullName: 'Исполнитель68',
            id: 'e268e5d2-0f58-4a8e-81bf-ccb3f0d5df6c'
          }
        ],
        actualStartDate: '02/25/2024 16:00',
        plannedEndDate: '02/26/2024 16:00',
        actualEndDate: '02/26/2024 16:00',
        priority: 'Средний',
        id: 'c637cd08-c2c6-461b-aa37-623897ad53b6'
      },
      {
        description: '',

        tasklName: 'Наряд 69',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 69',
        department: {
          label: 'Фил Амурский',
          key: 'bb1fc16f-bd36-41a5-8b93-c6eec48ae377'
        },
        employees: [
          {
            fullName: 'Исполнитель69',
            id: '5e2be1a9-2bf4-4496-838e-174c66f7cc0e'
          }
        ],
        actualStartDate: '02/26/2024 16:00',
        plannedEndDate: '02/27/2024 16:00',
        actualEndDate: '02/27/2024 16:00',
        priority: 'Высокий',
        id: '831c0dbb-019c-41a7-a717-9de4f43d7206'
      },
      {
        description: '',

        tasklName: 'Наряд 70',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 70',
        department: {
          label: 'НТМиРС_Шокуров',
          key: 'e8be7512-e9f6-4b41-a4f1-219710e18d37'
        },
        employees: [
          {
            fullName: 'Исполнитель70',
            id: '665a6e9f-9f24-4ce3-baa3-21170bd95412'
          }
        ],
        actualStartDate: '02/27/2024 16:00',
        plannedEndDate: '02/28/2024 16:00',
        actualEndDate: '02/28/2024 16:00',
        priority: 'Низкий',
        id: '277b52ce-4e50-40ff-baf2-d5a4788914a7'
      },
      {
        description: '',

        tasklName: 'Наряд 71',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 71',
        department: {
          label: 'НТМиРС_Владимиров',
          key: 'cd4dde1e-0099-471b-aebb-9ce6e69a805b'
        },
        employees: [
          {
            fullName: 'Исполнитель71',
            id: '92a752f9-08f5-4041-9efb-d78190431bf3'
          }
        ],
        actualStartDate: '02/28/2024 16:00',
        plannedEndDate: '02/29/2024 16:00',
        actualEndDate: '02/29/2024 16:00',
        priority: 'Средний',
        id: '898a8a3c-0aad-4e5b-99e8-10e50926680d'
      },
      {
        description: '',

        tasklName: 'Наряд 72',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 72',
        department: {
          label: 'НТМиРС_Ворожейкина',
          key: '440b8c17-01d1-4531-97c0-f0f71649cc90'
        },
        employees: [
          {
            fullName: 'Исполнитель72',
            id: '972e9b2e-1716-4366-a8dd-31b8ed0d46b7'
          }
        ],
        actualStartDate: '02/29/2024 16:00',
        plannedEndDate: '03/01/2024 16:00',
        actualEndDate: '03/01/2024 16:00',
        priority: 'Высокий',
        id: 'cb89074f-17eb-4ac8-bad9-f171cc29e283'
      },
      {
        description: '',

        tasklName: 'Наряд 73',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 73',
        department: {
          label: 'НТМиРС_Щербакова',
          key: '20cd2414-d4a0-4ca0-bdec-08308214496c'
        },
        employees: [
          {
            fullName: 'Исполнитель73',
            id: '7a18ba7d-da05-4c99-92cd-ffecac226c3d'
          }
        ],
        actualStartDate: '03/01/2024 16:00',
        plannedEndDate: '03/02/2024 16:00',
        actualEndDate: '03/02/2024 16:00',
        priority: 'Низкий',
        id: '3812e5ad-db6b-447b-b393-24e83cc221c8'
      },
      {
        description: '',

        tasklName: 'Наряд 74',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 74',
        department: {
          label: 'НТМиРС_Макарова',
          key: '0a862fe7-8a57-43eb-b6de-36aeceade54d'
        },
        employees: [
          {
            fullName: 'Исполнитель74',
            id: '7d688f0f-b253-4b85-af4a-1322b83375c9'
          }
        ],
        actualStartDate: '03/02/2024 16:00',
        plannedEndDate: '03/03/2024 16:00',
        actualEndDate: '03/03/2024 16:00',
        priority: 'Средний',
        id: 'b7682abf-25bb-442c-b754-81405985c94e'
      },
      {
        description: '',

        tasklName: 'Наряд 75',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 75',
        department: {
          label: 'НТУМС Дальний Восток',
          key: '9b87ec32-6dd3-42ea-9e44-49641aa6cba9'
        },
        employees: [
          {
            fullName: 'Исполнитель75',
            id: 'c0674433-9087-4016-b548-e28adb26f4c5'
          }
        ],
        actualStartDate: '03/03/2024 16:00',
        plannedEndDate: '03/04/2024 16:00',
        actualEndDate: '03/04/2024 16:00',
        priority: 'Высокий',
        id: 'bbed831b-28b9-464b-b970-3f79ea33ba05'
      },
      {
        description: '',

        tasklName: 'Наряд 76',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 76',
        department: {
          label: 'Фил Новг и Псков',
          key: '0d872313-3bc6-4a57-965a-ed17ec61ba5e'
        },
        employees: [
          {
            fullName: 'Исполнитель76',
            id: 'eb35b70a-7e5a-448e-a28d-375d176e1bb0'
          }
        ],
        actualStartDate: '03/04/2024 16:00',
        plannedEndDate: '03/05/2024 16:00',
        actualEndDate: '03/05/2024 16:00',
        priority: 'Низкий',
        id: '01219069-0351-49ae-90fd-7ea1567e8b28'
      },
      {
        description: '',

        tasklName: 'Наряд 77',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 77',
        department: {
          label: 'Фил Коми',
          key: 'b6108a55-f8d9-4060-988d-d8ece21c8ac0'
        },
        employees: [
          {
            fullName: 'Исполнитель77',
            id: '2baa3cde-c694-4b8e-81de-dbcda68a61b2'
          }
        ],
        actualStartDate: '03/05/2024 16:00',
        plannedEndDate: '10/05/2023 10:00',
        actualEndDate: '10/05/2023 10:00',
        priority: 'Средний',
        id: 'f1ac8378-fb83-470e-a9d3-2b33b9df78a7'
      },
      {
        description: '',

        tasklName: 'Наряд 78',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 78',
        department: {
          label: 'Фил Калининград',
          key: '7649c1f5-af4b-4b22-b7cf-14c0bb58541c'
        },
        employees: [
          {
            fullName: 'Исполнитель78',
            id: 'da7f17d3-8b9a-466f-bcfc-ae1389111771'
          }
        ],
        actualStartDate: '10/05/2023 10:00',
        plannedEndDate: '10/06/2023 10:00',
        actualEndDate: '10/06/2023 10:00',
        priority: 'Высокий',
        id: '5e3e822d-8eb8-4384-82e8-fadc38a0abff'
      },
      {
        description: '',

        tasklName: 'Наряд 79',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 79',
        department: {
          label: 'Фил Архангельск',
          key: '509b1ba8-e232-416c-8c34-89bfd669ff17'
        },
        employees: [
          {
            fullName: 'Исполнитель79',
            id: 'febb2e6a-8953-4ccc-8701-be8f85ee8b4b'
          }
        ],
        actualStartDate: '10/06/2023 10:00',
        plannedEndDate: '10/07/2023 10:00',
        actualEndDate: '10/07/2023 10:00',
        priority: 'Низкий',
        id: '169cf737-fa8e-4d6c-a784-36a6228b6331'
      },
      {
        description: '',

        tasklName: 'Наряд 80',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 80',
        department: {
          label: 'Фил Карельский',
          key: '6a8605db-addd-4702-8d84-f52b044ebc44'
        },
        employees: [
          {
            fullName: 'Исполнитель 1',
            id: 'd637e898-94ad-46fd-a366-00d21c957e32'
          }
        ],
        actualStartDate: '10/07/2023 10:00',
        plannedEndDate: '10/08/2023 10:00',
        actualEndDate: '10/08/2023 10:00',
        priority: 'Средний',
        id: 'd1bb4c2f-50ea-4ceb-a35a-85f1f714767f'
      },
      {
        description: '',

        tasklName: 'Наряд 81',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 81',
        department: {
          label: 'Фил Вологодский',
          key: '763365d9-4f12-468c-9c43-c4cd25f5a41f'
        },
        employees: [
          {
            fullName: 'Исполнитель 2',
            id: '5a38e5c4-b655-4c56-bd11-6dc681d3b860'
          }
        ],
        actualStartDate: '10/08/2023 10:00',
        plannedEndDate: '10/09/2023 10:00',
        actualEndDate: '10/09/2023 10:00',
        priority: 'Высокий',
        id: '1d48943a-f522-4743-9cac-a64dfcf35420'
      },
      {
        description: '',

        tasklName: 'Наряд 82',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 82',
        department: {
          label: 'Фил Мурманск',
          key: 'e6f684f5-09ec-4f30-86cf-527b6c61842b'
        },
        employees: [
          {
            fullName: 'Исполнитель 3',
            id: '2d072795-2921-4c76-a09f-532ed1f0da65'
          }
        ],
        actualStartDate: '10/09/2023 10:00',
        plannedEndDate: '10/10/2023 10:00',
        actualEndDate: '10/10/2023 10:00',
        priority: 'Низкий',
        id: 'f5b36894-8a15-4319-99a5-ffc3e07fbd3b'
      },
      {
        description: '',

        tasklName: 'Наряд 83',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 83',
        department: {
          label: 'НФТС',
          key: '811b92a1-11c3-4e6a-8084-6371c74a4099'
        },
        employees: [
          {
            fullName: 'Исполнитель 4',
            id: '1c235401-d947-4574-a50f-9401677bece6'
          }
        ],
        actualStartDate: '10/10/2023 10:00',
        plannedEndDate: '10/11/2023 10:00',
        actualEndDate: '10/11/2023 10:00',
        priority: 'Средний',
        id: '0759fdc6-ca17-4b2a-a9e3-294684f4003a'
      },
      {
        description: '',

        tasklName: 'Наряд 84',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 84',
        department: {
          label: 'ДЭТИ',
          key: 'd0383111-aefc-4719-9ceb-be0e18dd11d2'
        },
        employees: [
          {
            fullName: 'Исполнитель 5',
            id: 'fdc0919a-9e04-4250-97ce-275f085167e8'
          }
        ],
        actualStartDate: '10/11/2023 10:00',
        plannedEndDate: '10/12/2023 10:00',
        actualEndDate: '10/12/2023 10:00',
        priority: 'Высокий',
        id: '4cce9020-fee1-4e91-8961-11c12a007e18'
      },
      {
        description: '',

        tasklName: 'Наряд 85',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 85',
        department: {
          label: 'НТУМС Новгородский филиал',
          key: '571c721e-34ec-4a2d-bd71-a0c2e0f94db0'
        },
        employees: [
          {
            fullName: 'Исполнитель 6',
            id: '67ee4f64-a230-4977-9777-1a55ccf404db'
          }
        ],
        actualStartDate: '10/12/2023 10:00',
        plannedEndDate: '10/13/2023 10:00',
        actualEndDate: '10/13/2023 10:00',
        priority: 'Низкий',
        id: 'ea2f6d5b-b365-4806-9239-9b9280cbaaec'
      },
      {
        description: '',

        tasklName: 'Наряд 86',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 86',
        department: {
          label: 'НТУМС Вологодский филиал',
          key: 'e697276a-cdb4-4b34-8262-a222997b6df4'
        },
        employees: [
          {
            fullName: 'Исполнитель 7',
            id: 'b81e6890-6bab-4bb6-b2bb-4995d2576292'
          }
        ],
        actualStartDate: '10/13/2023 10:00',
        plannedEndDate: '10/14/2023 10:00',
        actualEndDate: '10/14/2023 10:00',
        priority: 'Средний',
        id: 'b2fcde7a-aded-4148-9da6-abd9a5868480'
      },
      {
        description: '',

        tasklName: 'Наряд 87',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 87',
        department: {
          label: 'НТМиРС_Борисов',
          key: '564468cd-13ce-4029-be9a-b8c90a041fae'
        },
        employees: [
          {
            fullName: 'Исполнитель 8',
            id: '582663c6-f3cc-4f54-bf18-1128a9f1afaa'
          }
        ],
        actualStartDate: '10/14/2023 10:00',
        plannedEndDate: '10/15/2023 10:00',
        actualEndDate: '10/15/2023 10:00',
        priority: 'Высокий',
        id: 'b11a23a1-a824-4001-98d6-f74e688b0a9b'
      },
      {
        description: '',

        tasklName: 'Наряд 88',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 88',
        department: {
          label: 'НТМиРС_Иванцов',
          key: '476b0c3f-502d-4687-abf2-bae069f663c4'
        },
        employees: [
          {
            fullName: 'Исполнитель 9',
            id: 'd6efea63-14c8-4fca-aced-8bdc89aa4a45'
          }
        ],
        actualStartDate: '10/15/2023 10:00',
        plannedEndDate: '10/16/2023 10:00',
        actualEndDate: '10/16/2023 10:00',
        priority: 'Низкий',
        id: '74c0fac5-c76a-40c3-b1f9-926de07d5706'
      },
      {
        description: '',

        tasklName: 'Наряд 89',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 89',
        department: {
          label: 'НТМиРС_Назаров',
          key: '5d6c5a37-df8d-4c1d-97c9-969c3d9b5e7c'
        },
        employees: [
          {
            fullName: 'Исполнитель 10',
            id: 'e2644ce4-4d89-4c0c-893f-ea2bf9f032fa'
          }
        ],
        actualStartDate: '10/16/2023 10:00',
        plannedEndDate: '10/17/2023 10:00',
        actualEndDate: '10/17/2023 10:00',
        priority: 'Средний',
        id: '2d90d8cb-772c-4137-b335-187219361c94'
      },
      {
        description: '',

        tasklName: 'Наряд 90',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 90',
        department: {
          label: 'Фил Иркутский',
          key: '7132a0f7-31b1-48c8-90ba-f0bd5094a399'
        },
        employees: [
          {
            fullName: 'Исполнитель 11',
            id: '34c7561e-257a-497d-b9e1-5829f155e87a'
          }
        ],
        actualStartDate: '10/17/2023 10:00',
        plannedEndDate: '10/18/2023 10:00',
        actualEndDate: '10/18/2023 10:00',
        priority: 'Высокий',
        id: '2fa8fe23-8cc8-4de6-8a00-2163f150a61f'
      },
      {
        description: '',

        tasklName: 'Наряд 91',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 91',
        department: {
          label: 'Фил Кемеровский',
          key: '90cc7e32-5d20-413f-86af-594af9e3ae7b'
        },
        employees: [
          {
            fullName: 'Исполнитель 12',
            id: 'fefd9f50-adcd-44fe-8f38-bf78687b4ed8'
          }
        ],
        actualStartDate: '10/18/2023 10:00',
        plannedEndDate: '10/19/2023 10:00',
        actualEndDate: '10/19/2023 10:00',
        priority: 'Низкий',
        id: '08f8f593-f703-4028-a2e4-cc0cd0f9e0fd'
      },
      {
        description: '',

        tasklName: 'Наряд 92',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 92',
        department: {
          label: 'НТМиРС_Пронина',
          key: 'e805b7ab-8537-499e-a777-a9dd88167911'
        },
        employees: [
          {
            fullName: 'Исполнитель 13',
            id: '0cfdd90c-45ce-4200-ace1-e802fa8fdc15'
          }
        ],
        actualStartDate: '10/19/2023 10:00',
        plannedEndDate: '10/20/2023 10:00',
        actualEndDate: '10/20/2023 10:00',
        priority: 'Средний',
        id: '59bf674d-9a73-4437-aead-906ca6c1adaf'
      },
      {
        description: '',

        tasklName: 'Наряд 93',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 93',
        department: {
          label: 'Фил Новосибирск',
          key: 'c3b98690-5871-4a2c-ac8c-38198a810bf0'
        },
        employees: [
          {
            fullName: 'Исполнитель 14',
            id: '8f5376c2-6bcf-4561-8acc-276f49cd2308'
          }
        ],
        actualStartDate: '10/20/2023 10:00',
        plannedEndDate: '10/21/2023 10:00',
        actualEndDate: '10/21/2023 10:00',
        priority: 'Высокий',
        id: 'cf734c0f-8821-4de7-832f-44cf4c01474d'
      },
      {
        description: '',

        tasklName: 'Наряд 94',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 94',
        department: {
          label: 'Фил Томский',
          key: '4e3dee2d-670e-4682-ad0a-fa7084521ef9'
        },
        employees: [
          {
            fullName: 'Исполнитель 15',
            id: '1e6f7059-e195-4fdd-b527-862c5bf38516'
          }
        ],
        actualStartDate: '10/21/2023 10:00',
        plannedEndDate: '10/22/2023 10:00',
        actualEndDate: '10/22/2023 10:00',
        priority: 'Низкий',
        id: '0292634f-ba0a-4f18-a4e5-659de9991fd2'
      },
      {
        description: '',

        tasklName: 'Наряд 95',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 95',
        department: {
          label: 'Фил Красноярский',
          key: '18df00e8-9b8b-4368-8232-e4c06526e6d3'
        },
        employees: [
          {
            fullName: 'Исполнитель 16',
            id: '0610cae1-9088-4d6b-9010-52531380ab73'
          }
        ],
        actualStartDate: '10/22/2023 10:00',
        plannedEndDate: '10/23/2023 10:00',
        actualEndDate: '10/23/2023 10:00',
        priority: 'Средний',
        id: '19f77dc9-b20c-414b-8c5e-a352951e5331'
      },
      {
        description: '',

        tasklName: 'Наряд 96',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 96',
        department: {
          label: 'Фил Бурятский',
          key: '26e65cda-4b7f-4daf-9735-34fefef31603'
        },
        employees: [
          {
            fullName: 'Исполнитель 17',
            id: '485c5912-fdd3-4de0-9ae8-4b9fb8d7ecdc'
          }
        ],
        actualStartDate: '10/23/2023 10:00',
        plannedEndDate: '10/24/2023 10:00',
        actualEndDate: '10/24/2023 10:00',
        priority: 'Высокий',
        id: '25cc39c6-7c93-4718-969e-31455b5be962'
      },
      {
        description: '',

        tasklName: 'Наряд 97',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 97',
        department: {
          label: 'Фил Алтайский',
          key: 'a96fd738-a0b3-4ad2-8dc2-26a43730a7bc'
        },
        employees: [
          {
            fullName: 'Исполнитель 18',
            id: '774c78e7-cb9f-40cd-b2b5-36ace4124705'
          }
        ],
        actualStartDate: '10/24/2023 10:00',
        plannedEndDate: '10/25/2023 10:00',
        actualEndDate: '10/25/2023 10:00',
        priority: 'Низкий',
        id: '39470d68-4dc4-401b-ba46-d2923fc23be1'
      },
      {
        description: '',

        tasklName: 'Наряд 98',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 98',
        department: {
          label: 'ДРОС Сибирь',
          key: '1c2909ad-3390-4cf6-a73e-20dd4e59d5cd'
        },
        employees: [
          {
            fullName: 'Исполнитель 19',
            id: '81e072de-03e6-43e8-aa84-be66c89fb69f'
          }
        ],
        actualStartDate: '10/25/2023 10:00',
        plannedEndDate: '10/26/2023 10:00',
        actualEndDate: '10/26/2023 10:00',
        priority: 'Средний',
        id: '83432623-8f0a-4999-b095-de43d1692eea'
      },
      {
        description: '',

        tasklName: 'Наряд 99',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 99',
        department: {
          label: 'НТМиРС_Волобуев',
          key: '73f9ce4e-c89d-4837-b48c-de011de1c77b'
        },
        employees: [
          {
            fullName: 'Исполнитель 20',
            id: '46a2d6be-3b64-48b0-a2ca-23f3ea5a4520'
          }
        ],
        actualStartDate: '10/26/2023 10:00',
        plannedEndDate: '02/24/2024 16:00',
        actualEndDate: '02/24/2024 16:00',
        priority: 'Высокий',
        id: 'ef557f38-7065-4bf0-972d-06af325bc741'
      },
      {
        description: '',

        tasklName: 'Наряд 100',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 100',
        department: {
          label: 'НТМиРС_Дурова',
          key: 'a41b083d-4f40-4ec8-9776-452b7363a95f'
        },
        employees: [
          {
            fullName: 'Исполнитель 21',
            id: 'eaa88add-1d2b-4e24-98b5-0e2e924ab6e1'
          }
        ],
        actualStartDate: '02/24/2024 16:00',
        plannedEndDate: '02/25/2024 16:00',
        actualEndDate: '02/25/2024 16:00',
        priority: 'Низкий',
        id: 'be06dd27-984c-47d9-a5c7-c87b748f387e'
      },
      {
        description: '',

        tasklName: 'Наряд 101',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 101',
        department: {
          label: 'НТМиРС_Казанцев',
          key: 'f880214e-5471-48f8-b4ad-7701ce9ef8f8'
        },
        employees: [
          {
            fullName: 'Исполнитель 22',
            id: '4b3ededb-9920-4660-a531-9cd6dbc6a192'
          }
        ],
        actualStartDate: '02/25/2024 16:00',
        plannedEndDate: '02/26/2024 16:00',
        actualEndDate: '02/26/2024 16:00',
        priority: 'Средний',
        id: '0f287b98-0244-48b9-9a06-3c1d75eca0fc'
      },
      {
        description: '',

        tasklName: 'Наряд 102',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 102',
        department: {
          label: 'Фил Омский',
          key: '2d06637c-90c8-4c7a-aa6c-43f71a53489c'
        },
        employees: [
          {
            fullName: 'Исполнитель 23',
            id: '78010e36-f2e3-4a53-a578-90cf8489a17e'
          }
        ],
        actualStartDate: '02/26/2024 16:00',
        plannedEndDate: '02/27/2024 16:00',
        actualEndDate: '02/27/2024 16:00',
        priority: 'Высокий',
        id: '291d7451-1cd9-4e31-a2cd-29c15e1feda1'
      },
      {
        description: '',

        tasklName: 'Наряд 103',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 103',
        department: {
          label: 'НТМиРС_Гавриленко',
          key: '17a6af5b-45d8-4a10-8f03-752f8be8e11b'
        },
        employees: [
          {
            fullName: 'Исполнитель 24',
            id: 'a8cafd19-7007-4b09-870c-aa89dae8897a'
          }
        ],
        actualStartDate: '02/27/2024 16:00',
        plannedEndDate: '02/28/2024 16:00',
        actualEndDate: '02/28/2024 16:00',
        priority: 'Низкий',
        id: 'c0229699-3e82-42b0-b2c3-dfbc9122eb7b'
      },
      {
        description: '',

        tasklName: 'Наряд 104',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 104',
        department: {
          label: 'НТМиРС_Скорик',
          key: 'c6dfa9d4-3f81-4668-9416-69715fbf0704'
        },
        employees: [
          {
            fullName: 'Исполнитель 25',
            id: '10cff5bf-6ed9-48af-8bb4-60954724341a'
          }
        ],
        actualStartDate: '02/28/2024 16:00',
        plannedEndDate: '02/29/2024 16:00',
        actualEndDate: '02/29/2024 16:00',
        priority: 'Средний',
        id: '6e55f10f-2128-49bb-ba06-1afe0f9ff7cd'
      },
      {
        description: '',

        tasklName: 'Наряд 105',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 105',
        department: {
          label: ' Дирекция',
          key: 'f16379e2-f651-4538-8b81-7e050175a9f2'
        },
        employees: [
          {
            fullName: 'Исполнитель 26',
            id: '20d99d01-53e1-4989-9d9a-c324a1b9251b'
          }
        ],
        actualStartDate: '02/29/2024 16:00',
        plannedEndDate: '03/01/2024 16:00',
        actualEndDate: '03/01/2024 16:00',
        priority: 'Высокий',
        id: '40cd2ce9-2308-4157-b8fb-f814af95a0ef'
      },
      {
        description: '',

        tasklName: 'Наряд 106',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 106',
        department: {
          label: 'НТМиРС_Беляев',
          key: 'c4ed1c27-d061-4600-a96a-676aaa8cae63'
        },
        employees: [
          {
            fullName: 'Исполнитель 27',
            id: '5267227d-f0a5-4f14-8ba5-eb277c99abff'
          }
        ],
        actualStartDate: '03/01/2024 16:00',
        plannedEndDate: '03/02/2024 16:00',
        actualEndDate: '03/02/2024 16:00',
        priority: 'Низкий',
        id: '34a69f58-7bee-4c60-8574-4274288bb242'
      },
      {
        description: '',

        tasklName: 'Наряд 107',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 107',
        department: {
          label: 'НТМиРС_Суханова',
          key: 'e77a1b54-e331-4f26-a120-5a72b9dcc042'
        },
        employees: [
          {
            fullName: 'Исполнитель 28',
            id: '67fd63a7-2895-4b8e-8768-99ff705ce410'
          }
        ],
        actualStartDate: '03/02/2024 16:00',
        plannedEndDate: '03/03/2024 16:00',
        actualEndDate: '03/03/2024 16:00',
        priority: 'Средний',
        id: '479cb916-bd2c-43cb-8545-4aed9c6a57d9'
      },
      {
        description: '',

        tasklName: 'Наряд 108',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 108',
        department: {
          label: 'Фил Тюм и Курган',
          key: '5be4da8b-a5b3-4d73-9017-1cec7898a3c3'
        },
        employees: [
          {
            fullName: 'Исполнитель 29',
            id: '559d7abc-7489-42f2-98a7-579accebdc1f'
          }
        ],
        actualStartDate: '03/03/2024 16:00',
        plannedEndDate: '03/04/2024 16:00',
        actualEndDate: '03/04/2024 16:00',
        priority: 'Высокий',
        id: '219a7382-95a0-4add-9fa8-12ef11bc1d54'
      },
      {
        description: '',

        tasklName: 'Наряд 109',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 109',
        department: {
          label: 'НТМиРС_Дружков',
          key: 'df24b642-4985-4969-be22-41a64427f3ac'
        },
        employees: [
          {
            fullName: 'Исполнитель 30',
            id: '066ea32c-d503-4c2a-a861-3baad63a537e'
          }
        ],
        actualStartDate: '03/04/2024 16:00',
        plannedEndDate: '03/05/2024 16:00',
        actualEndDate: '03/05/2024 16:00',
        priority: 'Низкий',
        id: '061f7319-548e-491c-99ba-929685149232'
      },
      {
        description: '',

        tasklName: 'Наряд 110',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 110',
        department: {
          label: 'Фил Ханты-Манс',
          key: '4e403ba8-bd28-451f-9d30-e930a9339226'
        },
        employees: [
          {
            fullName: 'Исполнитель 31',
            id: '409d67af-5073-470d-bf76-c223bed944f5'
          }
        ],
        actualStartDate: '03/05/2024 16:00',
        plannedEndDate: '10/05/2023 10:00',
        actualEndDate: '10/05/2023 10:00',
        priority: 'Средний',
        id: 'c2ad069c-2b01-431e-b2e0-25e4c74cddd6'
      },
      {
        description: '',

        tasklName: 'Наряд 111',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 111',
        department: {
          label: 'НТМиРС_Скударнов',
          key: '0b34acaa-924b-4218-9c59-6dd7431be6be'
        },
        employees: [
          {
            fullName: 'Исполнитель 32',
            id: 'a7184f0f-0126-475c-a895-4bcf401836ed'
          }
        ],
        actualStartDate: '10/05/2023 10:00',
        plannedEndDate: '10/06/2023 10:00',
        actualEndDate: '10/06/2023 10:00',
        priority: 'Высокий',
        id: '2e085bb4-64c7-45b5-97a7-fd91d4a4aec3'
      },
      {
        description: '',

        tasklName: 'Наряд 112',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 112',
        department: {
          label: 'НТМиРС_Кудрина',
          key: '9349d5c8-20d6-461e-9c3a-2d037aa36b4b'
        },
        employees: [
          {
            fullName: 'Исполнитель 33',
            id: '14981b83-ea25-432c-bb73-807e7f1d8ed0'
          }
        ],
        actualStartDate: '10/06/2023 10:00',
        plannedEndDate: '10/07/2023 10:00',
        actualEndDate: '10/07/2023 10:00',
        priority: 'Низкий',
        id: '962bc98a-9447-49c6-bacb-84d3705405e9'
      },
      {
        description: '',

        tasklName: 'Наряд 113',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 113',
        department: {
          label: 'НТМиРС_Соколова',
          key: '11153278-97d0-40e6-acdf-f2e19121feb0'
        },
        employees: [
          {
            fullName: 'Исполнитель 34',
            id: '745281f4-9648-4c32-b817-f59a1af52b7b'
          }
        ],
        actualStartDate: '10/07/2023 10:00',
        plannedEndDate: '10/08/2023 10:00',
        actualEndDate: '10/08/2023 10:00',
        priority: 'Средний',
        id: 'ab8df9c1-7ff8-4bbd-88bb-6bae71878d0a'
      },
      {
        description: '',

        tasklName: 'Наряд 114',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 114',
        department: {
          label: 'Фил Пермский',
          key: '97de1f58-3187-470b-b657-fbc5d0181088'
        },
        employees: [
          {
            fullName: 'Исполнитель 35',
            id: '487da271-7124-4e35-9834-da2dd263a2e1'
          }
        ],
        actualStartDate: '10/08/2023 10:00',
        plannedEndDate: '10/09/2023 10:00',
        actualEndDate: '10/09/2023 10:00',
        priority: 'Высокий',
        id: '830ee4ae-0c9e-47f4-bacf-3c762198ffa8'
      },
      {
        description: '',

        tasklName: 'Наряд 115',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 115',
        department: {
          label: 'Фил Челябинский',
          key: 'e7f9f071-36d4-4952-8bef-f815c49b4785'
        },
        employees: [
          {
            fullName: 'Исполнитель 36',
            id: '50f0a29a-d671-46c5-b568-c109fe91c645'
          }
        ],
        actualStartDate: '10/09/2023 10:00',
        plannedEndDate: '10/10/2023 10:00',
        actualEndDate: '10/10/2023 10:00',
        priority: 'Низкий',
        id: '7da73712-8e53-4ffb-9aba-d965aa51c16d'
      },
      {
        description: '',

        tasklName: 'Наряд 116',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 116',
        department: {
          label: 'Фил Екатеринбург',
          key: '8081289d-417e-469a-a259-f2e8c709c491'
        },
        employees: [
          {
            fullName: 'Исполнитель 37',
            id: '30d79090-4ee7-4c06-8a55-21ca69f3c651'
          }
        ],
        actualStartDate: '10/10/2023 10:00',
        plannedEndDate: '10/11/2023 10:00',
        actualEndDate: '10/11/2023 10:00',
        priority: 'Средний',
        id: '3f767f8c-88f0-4409-93d3-bf632f66a270'
      },
      {
        description: '',

        tasklName: 'Наряд 117',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 117',
        department: {
          label: 'ДРОС Урал',
          key: '7d0515ba-9b36-40b1-910d-72040675ff2f'
        },
        employees: [
          {
            fullName: 'Исполнитель 38',
            id: 'd573943c-8691-44cc-a2d4-684bcfeb0a97'
          }
        ],
        actualStartDate: '10/11/2023 10:00',
        plannedEndDate: '10/12/2023 10:00',
        actualEndDate: '10/12/2023 10:00',
        priority: 'Высокий',
        id: 'c330054a-ec69-4236-bc6f-b558d94e162b'
      },
      {
        description: '',

        tasklName: 'Наряд 118',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 118',
        department: {
          label: 'НТМиРС_Тупицын',
          key: '52755bd6-dd68-45a6-839b-95be09b9bfe2'
        },
        employees: [
          {
            fullName: 'Исполнитель 39',
            id: 'fd3a15fa-f4ca-4b84-9ba2-25f3406f6018'
          }
        ],
        actualStartDate: '10/12/2023 10:00',
        plannedEndDate: '10/13/2023 10:00',
        actualEndDate: '10/13/2023 10:00',
        priority: 'Низкий',
        id: 'ba69bedd-cf19-4f84-b509-5abdffbdc95a'
      },
      {
        description: '',

        tasklName: 'Наряд 119',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 119',
        department: {
          label: 'НТМиРС_Григорьев',
          key: '70fc8a98-cc4e-450b-ae82-8d6c92960a73'
        },
        employees: [
          {
            fullName: 'Исполнитель 40',
            id: 'e4f73476-aa72-418a-85a8-01def5aa5f39'
          }
        ],
        actualStartDate: '10/13/2023 10:00',
        plannedEndDate: '10/14/2023 10:00',
        actualEndDate: '10/14/2023 10:00',
        priority: 'Средний',
        id: 'e2c7a5ec-d172-4c9c-b1f6-61d3e8940fd1'
      },
      {
        description: '',

        tasklName: 'Наряд 120',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 120',
        department: {
          label: 'НТМиРС_Зиновьев',
          key: '31e87e20-2047-423e-b6ab-dda7d98cbef0'
        },
        employees: [
          {
            fullName: 'Исполнитель 41',
            id: '664a602e-d0b9-4272-9999-e832d1d5f38e'
          }
        ],
        actualStartDate: '10/14/2023 10:00',
        plannedEndDate: '10/15/2023 10:00',
        actualEndDate: '10/15/2023 10:00',
        priority: 'Высокий',
        id: '4cddc8ee-828f-4d61-ae25-dc974f2875a7'
      },
      {
        description: '',

        tasklName: 'Наряд 121',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 121',
        department: {
          label: 'НТМиРС_Коновалов',
          key: '8fd6f9ca-e28b-4bcb-ab73-6967b26e6ed5'
        },
        employees: [
          {
            fullName: 'Исполнитель 42',
            id: 'f63d39ac-191b-4b46-b3f9-378b98f048b2'
          }
        ],
        actualStartDate: '10/15/2023 10:00',
        plannedEndDate: '10/16/2023 10:00',
        actualEndDate: '10/16/2023 10:00',
        priority: 'Низкий',
        id: '06aa5b41-b605-4331-9d46-7aacff9450e0'
      },
      {
        description: '',

        tasklName: 'Наряд 122',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 122',
        department: {
          label: 'НТМиРС_Садыков',
          key: '7a96b938-50d0-4a8a-b6dd-41f591a82859'
        },
        employees: [
          {
            fullName: 'Исполнитель 43',
            id: 'e3290da6-7c5e-458c-80f8-9f91db91c803'
          }
        ],
        actualStartDate: '10/16/2023 10:00',
        plannedEndDate: '10/17/2023 10:00',
        actualEndDate: '10/17/2023 10:00',
        priority: 'Средний',
        id: '5f4667e8-a6ab-4461-a734-ad5761f75f24'
      },
      {
        description: '',

        tasklName: 'Наряд 123',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 123',
        department: {
          label: 'НТМиРС_Осипова',
          key: '58ca93c9-e158-4a2d-9edd-b655150ba41a'
        },
        employees: [
          {
            fullName: 'Исполнитель 44',
            id: 'eb480d39-7c5e-4b08-9f1e-6d2a875894e3'
          }
        ],
        actualStartDate: '10/17/2023 10:00',
        plannedEndDate: '10/18/2023 10:00',
        actualEndDate: '10/18/2023 10:00',
        priority: 'Высокий',
        id: '3e7d6179-26ee-4710-9a4f-900610aafcac'
      },
      {
        description: '',

        tasklName: 'Наряд 124',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 124',
        department: {
          label: 'НТМиРС_Афонасенко',
          key: '9b5df88b-b3d7-4640-a9b8-2233ab7b7663'
        },
        employees: [
          {
            fullName: 'Исполнитель 45',
            id: 'a27cc200-e62d-4d3e-bc8a-639b0de15919'
          }
        ],
        actualStartDate: '10/18/2023 10:00',
        plannedEndDate: '10/19/2023 10:00',
        actualEndDate: '10/19/2023 10:00',
        priority: 'Низкий',
        id: '27ed0c6d-7379-4c7d-8394-f8ea4e8b36e4'
      },
      {
        description: '',

        tasklName: 'Наряд 125',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 125',
        department: {
          label: 'НТМиРС_Насонов',
          key: '308f1733-0f5a-45b5-951f-99b8a3606947'
        },
        employees: [
          {
            fullName: 'Исполнитель 46',
            id: 'b2e25e66-ab7f-45e6-8dc0-e65320a67e13'
          }
        ],
        actualStartDate: '10/19/2023 10:00',
        plannedEndDate: '10/20/2023 10:00',
        actualEndDate: '10/20/2023 10:00',
        priority: 'Средний',
        id: 'cc68862f-cff5-485a-aaa6-14542da589d5'
      },
      {
        description: '',

        tasklName: 'Наряд 126',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 126',
        department: {
          label: 'НТМиРС_Зеленин',
          key: '0766a115-0b15-4e53-b4d9-c23c4971be44'
        },
        employees: [
          {
            fullName: 'Исполнитель 47',
            id: '9eb0ae6c-eed8-4b34-ba08-96954923bd6f'
          }
        ],
        actualStartDate: '10/20/2023 10:00',
        plannedEndDate: '10/21/2023 10:00',
        actualEndDate: '10/21/2023 10:00',
        priority: 'Высокий',
        id: '4dedcf85-ed05-4d90-9c97-4cc78f07daac'
      },
      {
        description: '',

        tasklName: 'Наряд 127',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 127',
        department: {
          label: 'НТМиРС_Нечаев',
          key: 'e1f71017-b0fe-4fbd-b29d-20dd56da3a33'
        },
        employees: [
          {
            fullName: 'Исполнитель 48',
            id: 'd1abd60c-5f34-499f-92f1-92a02cfcf962'
          }
        ],
        actualStartDate: '10/21/2023 10:00',
        plannedEndDate: '10/22/2023 10:00',
        actualEndDate: '10/22/2023 10:00',
        priority: 'Низкий',
        id: '5a83c076-3660-48e0-a4c9-2d71a68b5994'
      },
      {
        description: '',

        tasklName: 'Наряд 128',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 128',
        department: {
          label: 'НТМиРС_Синицын',
          key: '3fb1315f-a3d2-4448-9213-898aefc3d60b'
        },
        employees: [
          {
            fullName: 'Исполнитель 49',
            id: '99e1b8ac-e01e-4f64-80c8-e896881b1b57'
          }
        ],
        actualStartDate: '10/22/2023 10:00',
        plannedEndDate: '10/23/2023 10:00',
        actualEndDate: '10/23/2023 10:00',
        priority: 'Средний',
        id: '229cc608-b5ea-41f3-aeba-a10f65f1a88e'
      },
      {
        description: '',

        tasklName: 'Наряд 129',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 129',
        department: {
          label: 'НТМиРС_Суханюк',
          key: 'b46ac1b8-de13-4dec-b3fd-7168cde4c2c5'
        },
        employees: [
          {
            fullName: 'Исполнитель 50',
            id: '577848c2-5c1d-4ce8-853e-4801b8e48a74'
          }
        ],
        actualStartDate: '10/23/2023 10:00',
        plannedEndDate: '10/24/2023 10:00',
        actualEndDate: '10/24/2023 10:00',
        priority: 'Высокий',
        id: 'e909d5b2-b362-4723-ab15-9be63aac8284'
      },
      {
        description: '',

        tasklName: 'Наряд 130',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 130',
        department: {
          label: 'Фил Ямало-Ненец',
          key: '4a2f370a-1b89-40d4-8454-aa2cfd5c5700'
        },
        employees: [
          {
            fullName: 'Исполнитель 51',
            id: 'b423814d-1d36-49f7-9610-9424b5f8daee'
          }
        ],
        actualStartDate: '10/24/2023 10:00',
        plannedEndDate: '10/25/2023 10:00',
        actualEndDate: '10/25/2023 10:00',
        priority: 'Низкий',
        id: 'e98669f7-599c-4ba3-a37f-9111fa481edc'
      },
      {
        description: '',

        tasklName: 'Наряд 131',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 131',
        department: {
          label: 'НТМиРС_Подвашецкий ',
          key: 'cf05cb11-ca7f-4ea0-b490-74fe7f74f8fb'
        },
        employees: [
          {
            fullName: 'Исполнитель 52',
            id: 'ec303f04-a70c-4cfb-ab28-3ea2cd4617ab'
          }
        ],
        actualStartDate: '10/25/2023 10:00',
        plannedEndDate: '10/26/2023 10:00',
        actualEndDate: '10/26/2023 10:00',
        priority: 'Средний',
        id: '742d98fe-0a49-4dbc-93b5-a7e03b469119'
      },
      {
        description: '',

        tasklName: 'Наряд 132',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 132',
        department: {
          label: 'НТМиРС Центр',
          key: 'cd98f5de-e5ea-44ed-8ecc-1266bd97e98c'
        },
        employees: [
          {
            fullName: 'Исполнитель 53',
            id: '6196c433-0de5-4bf6-9422-fee03ccd9b17'
          }
        ],
        actualStartDate: '10/26/2023 10:00',
        plannedEndDate: '02/24/2024 16:00',
        actualEndDate: '02/24/2024 16:00',
        priority: 'Высокий',
        id: '3147c474-0f3c-416d-ab3c-7b256a26fd76'
      },
      {
        description: '',

        tasklName: 'Наряд 133',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 133',
        department: {
          label: 'Фил Смоленский',
          key: 'cc9824c6-a0fe-41c9-9d06-461c58830394'
        },
        employees: [
          {
            fullName: 'Исполнитель 54',
            id: '962ee396-268b-49ec-aaf5-c591f3267e96'
          }
        ],
        actualStartDate: '02/24/2024 16:00',
        plannedEndDate: '02/25/2024 16:00',
        actualEndDate: '02/25/2024 16:00',
        priority: 'Низкий',
        id: '0ed4c7a0-7f32-4e14-a950-80573e70b59c'
      },
      {
        description: '',

        tasklName: 'Наряд 134',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 134',
        department: {
          label: 'ТЦТЭТ Западный',
          key: '0c448d7c-66ad-46f7-946b-b2322ca2c00b'
        },
        employees: [
          {
            fullName: 'Исполнитель 55',
            id: 'cae7826f-b90e-4341-b40a-49a3489a5213'
          }
        ],
        actualStartDate: '02/25/2024 16:00',
        plannedEndDate: '02/26/2024 16:00',
        actualEndDate: '02/26/2024 16:00',
        priority: 'Средний',
        id: 'e8a01887-eaf8-4798-bacf-094c37f419dd'
      },
      {
        description: '',

        tasklName: 'Наряд 135',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 135',
        department: {
          label: 'МГУТЭ',
          key: '245e276b-1d04-4870-879f-ddb332086910'
        },
        employees: [
          {
            fullName: 'Исполнитель 56',
            id: '7880664c-6f02-45f2-9333-453a0d452bc8'
          }
        ],
        actualStartDate: '02/26/2024 16:00',
        plannedEndDate: '02/27/2024 16:00',
        actualEndDate: '02/27/2024 16:00',
        priority: 'Высокий',
        id: '3055c170-16d1-4ef6-84ca-47fd9a42964c'
      },
      {
        description: '',

        tasklName: 'Наряд 136',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 136',
        department: {
          label: 'ТЦТЭТ Восточный',
          key: '63420ba3-2224-42a6-9baf-d5d2e5e03828'
        },
        employees: [
          {
            fullName: 'Исполнитель 57',
            id: 'cf8a5764-94a9-49ad-9a2b-ea72107fce3f'
          }
        ],
        actualStartDate: '02/27/2024 16:00',
        plannedEndDate: '02/28/2024 16:00',
        actualEndDate: '02/28/2024 16:00',
        priority: 'Низкий',
        id: '1a4f99e8-3386-4884-9606-744e3893f234'
      },
      {
        description: '',

        tasklName: 'Наряд 137',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 137',
        department: {
          label: 'Фил Ярос и Костр',
          key: '12746a25-e00c-452d-b395-70ae8ecb8ae4'
        },
        employees: [
          {
            fullName: 'Исполнитель 58',
            id: '1e59ed0a-4d95-43bd-a6d5-0c8e0f755482'
          }
        ],
        actualStartDate: '02/28/2024 16:00',
        plannedEndDate: '02/29/2024 16:00',
        actualEndDate: '02/29/2024 16:00',
        priority: 'Средний',
        id: '55980110-1dc4-48f6-92eb-8bcb76fa6ebc'
      },
      {
        description: '',

        tasklName: 'Наряд 138',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 138',
        department: {
          label: 'Фил Тверской',
          key: '8c912204-4ee7-44a7-8048-df095f516956'
        },
        employees: [
          {
            fullName: 'Исполнитель 59',
            id: '2bfc945f-b7ca-4866-b046-c5824f19df57'
          }
        ],
        actualStartDate: '02/29/2024 16:00',
        plannedEndDate: '03/01/2024 16:00',
        actualEndDate: '03/01/2024 16:00',
        priority: 'Высокий',
        id: 'c6ba6cac-8715-436b-892b-252165a1ac30'
      },
      {
        description: '',

        tasklName: 'Наряд 139',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 139',
        department: {
          label: 'МОУТЭ',
          key: '60165c80-8d97-48d1-b650-35faf58e4987'
        },
        employees: [
          {
            fullName: 'Исполнитель 60',
            id: '6370ab3d-4f5e-449c-8ee8-d6cbdcb2aa2a'
          }
        ],
        actualStartDate: '03/01/2024 16:00',
        plannedEndDate: '03/02/2024 16:00',
        actualEndDate: '03/02/2024 16:00',
        priority: 'Низкий',
        id: 'e2e4417a-cf9d-49ed-9dd5-5a4349c25e77'
      },
      {
        description: '',

        tasklName: 'Наряд 140',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 140',
        department: {
          label: 'Фил Белгородский',
          key: '12049b69-a766-495f-8fb3-b17a47189ec7'
        },
        employees: [
          {
            fullName: 'Исполнитель 61',
            id: '500622e4-f5db-465c-912f-f264aca7da73'
          }
        ],
        actualStartDate: '03/02/2024 16:00',
        plannedEndDate: '03/03/2024 16:00',
        actualEndDate: '03/03/2024 16:00',
        priority: 'Средний',
        id: 'cf79f5de-beb0-4a62-9518-ef14442509af'
      },
      {
        description: '',

        tasklName: 'Наряд 141',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 141',
        department: {
          label: 'Фил Липецкий',
          key: 'd353438d-7389-4ba1-b857-2cea279dee7b'
        },
        employees: [
          {
            fullName: 'Исполнитель 62',
            id: '4b99caae-f2c7-44fa-9c59-b7c46e37c2e6'
          }
        ],
        actualStartDate: '03/03/2024 16:00',
        plannedEndDate: '03/04/2024 16:00',
        actualEndDate: '03/04/2024 16:00',
        priority: 'Высокий',
        id: 'd743c5ef-2c41-4b48-b295-70efbf3c33f9'
      },
      {
        description: '',

        tasklName: 'Наряд 142',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 142',
        department: {
          label: 'Фил Курский',
          key: 'f77a6d40-15e9-4c07-bc6c-b21354f9c6fc'
        },
        employees: [
          {
            fullName: 'Исполнитель 63',
            id: 'fe40e486-b840-4ba0-9eca-0fbcba6b4be1'
          }
        ],
        actualStartDate: '03/04/2024 16:00',
        plannedEndDate: '03/05/2024 16:00',
        actualEndDate: '03/05/2024 16:00',
        priority: 'Низкий',
        id: '1c401036-897e-4eea-af25-1d4e3efe2047'
      },
      {
        description: '',

        tasklName: 'Наряд 143',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 143',
        department: {
          label: 'Фил Калужский',
          key: '83e4f8d5-27e6-4771-bbc2-bfcf69c7b37d'
        },
        employees: [
          {
            fullName: 'Исполнитель 64',
            id: '72558a2a-488d-4d09-8cca-7de90b3d1f70'
          }
        ],
        actualStartDate: '03/05/2024 16:00',
        plannedEndDate: '10/05/2023 10:00',
        actualEndDate: '10/05/2023 10:00',
        priority: 'Средний',
        id: 'd264a756-602b-46f6-86fd-c14b15d2dac1'
      },
      {
        description: '',

        tasklName: 'Наряд 144',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 144',
        department: {
          label: 'Фил Тамбовск',
          key: 'd5398bd4-dc6f-4ba2-b33e-2dd3b0f63100'
        },
        employees: [
          {
            fullName: 'Исполнитель 65',
            id: 'd291bdaa-1326-486e-aa7a-4053a9fb31b7'
          }
        ],
        actualStartDate: '10/05/2023 10:00',
        plannedEndDate: '10/06/2023 10:00',
        actualEndDate: '10/06/2023 10:00',
        priority: 'Высокий',
        id: 'f9edfd42-e68b-4f70-bdfc-e074c7f5f218'
      },
      {
        description: '',

        tasklName: 'Наряд 145',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 145',
        department: {
          label: 'Фил Воронежский',
          key: '5d6412df-33c7-4789-b559-29c3f62224d3'
        },
        employees: [
          {
            fullName: 'Исполнитель 66',
            id: '3cf99130-5b8b-47b2-a0f8-2887847c4dd7'
          }
        ],
        actualStartDate: '10/06/2023 10:00',
        plannedEndDate: '10/07/2023 10:00',
        actualEndDate: '10/07/2023 10:00',
        priority: 'Низкий',
        id: '2384e46e-c042-4476-9e94-48a476166950'
      },
      {
        description: '',

        tasklName: 'Наряд 146',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 146',
        department: {
          label: 'Фил Влад и Иван',
          key: '0904a6b3-49ac-48e3-b07f-5f7207bdd5a5'
        },
        employees: [
          {
            fullName: 'Исполнитель 67',
            id: '57549667-616b-4aee-8081-45f7595a5127'
          }
        ],
        actualStartDate: '10/07/2023 10:00',
        plannedEndDate: '10/08/2023 10:00',
        actualEndDate: '10/08/2023 10:00',
        priority: 'Средний',
        id: '2b0b051a-dcb9-4600-9ae4-919bfb92e923'
      },
      {
        description: '',

        tasklName: 'Наряд 147',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 147',
        department: {
          label: 'Фил Брянск и Орл',
          key: '976ee475-17b1-4bb8-a0fc-3c88504756fa'
        },
        employees: [
          {
            fullName: 'Исполнитель 68',
            id: '5b4abe2c-6fb0-4171-a7fd-5d612dc8fcb4'
          }
        ],
        actualStartDate: '10/08/2023 10:00',
        plannedEndDate: '10/09/2023 10:00',
        actualEndDate: '10/09/2023 10:00',
        priority: 'Высокий',
        id: '1f049c02-f6b2-4b81-b95a-d5f5401e08ff'
      },
      {
        description: '',

        tasklName: 'Наряд 148',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 148',
        department: {
          label: 'Фил Астраханский',
          key: 'ccb55583-fa76-4734-921a-e248070b9e8b'
        },
        employees: [
          {
            fullName: 'Исполнитель 69',
            id: '524f8889-c6d5-4d4a-ae03-d7460bce14cd'
          }
        ],
        actualStartDate: '10/09/2023 10:00',
        plannedEndDate: '10/10/2023 10:00',
        actualEndDate: '10/10/2023 10:00',
        priority: 'Низкий',
        id: 'c9241a06-6edf-47e6-85c8-e67eeb1a0136'
      },
      {
        description: '',

        tasklName: 'Наряд 149',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 149',
        department: {
          label: 'ОУСС',
          key: '461cfe0f-6ab4-4907-86aa-2da756aeefc2'
        },
        employees: [
          {
            fullName: 'Исполнитель 70',
            id: 'f1abcdca-16b3-4113-84d1-d4c532253ccf'
          }
        ],
        actualStartDate: '10/10/2023 10:00',
        plannedEndDate: '10/11/2023 10:00',
        actualEndDate: '10/11/2023 10:00',
        priority: 'Средний',
        id: 'c1e4f5e5-4043-4ed1-ab5d-71912d165906'
      },
      {
        description: '',

        tasklName: 'Наряд 150',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 150',
        department: {
          label: 'Фил Каб-Балкарск',
          key: '0fe7d0c1-d0df-487b-81b3-012e863b6174'
        },
        employees: [
          {
            fullName: 'Исполнитель 71',
            id: 'd0ba0019-f38f-4d4c-bfef-a38cf09fe23f'
          }
        ],
        actualStartDate: '10/11/2023 10:00',
        plannedEndDate: '10/12/2023 10:00',
        actualEndDate: '10/12/2023 10:00',
        priority: 'Высокий',
        id: 'e2c00c29-8fc4-476d-b7c2-82b436e6ab5b'
      },
      {
        description: '',

        tasklName: 'Наряд 151',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 151',
        department: {
          label: 'НТМСиРС Юг',
          key: 'c7f60840-bd1f-4082-b14d-7db8635df55e'
        },
        employees: [
          {
            fullName: 'Исполнитель 72',
            id: '704629a5-8aa7-42ed-b769-93f3730e2734'
          }
        ],
        actualStartDate: '10/12/2023 10:00',
        plannedEndDate: '10/13/2023 10:00',
        actualEndDate: '10/13/2023 10:00',
        priority: 'Низкий',
        id: 'f7cddf59-5bcd-4201-9910-8bb24c681591'
      },
      {
        description: '',

        tasklName: 'Наряд 152',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 152',
        department: {
          label: 'Фил Дагестанский',
          key: '84ac4efb-96a4-4e19-9ac6-bfb87771c07d'
        },
        employees: [
          {
            fullName: 'Исполнитель 73',
            id: '6d661fdf-6cfb-47a8-ae35-366f32f40d21'
          }
        ],
        actualStartDate: '10/13/2023 10:00',
        plannedEndDate: '10/14/2023 10:00',
        actualEndDate: '10/14/2023 10:00',
        priority: 'Средний',
        id: '330ad094-6974-4e2f-8a31-f55af6dba8c1'
      },
      {
        description: '',

        tasklName: 'Наряд 153',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 153',
        department: {
          label: 'Фил Ставропольск',
          key: '03c640bb-865a-445b-af0e-dcfb9e453fde'
        },
        employees: [
          {
            fullName: 'Исполнитель 74',
            id: 'ba1834d1-e5e6-4424-b3e2-152749e160a4'
          }
        ],
        actualStartDate: '10/14/2023 10:00',
        plannedEndDate: '10/15/2023 10:00',
        actualEndDate: '10/15/2023 10:00',
        priority: 'Высокий',
        id: '262f21f3-113b-4647-9a57-f78cc998ff43'
      },
      {
        description: '',

        tasklName: 'Наряд 154',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 154',
        department: {
          label: 'Фил Калмыцкий',
          key: '586980df-0462-421a-b130-78cc6e2639c2'
        },
        employees: [
          {
            fullName: 'Исполнитель 75',
            id: 'b7fee5c3-1ce1-4362-9f97-e7d6b1844d88'
          }
        ],
        actualStartDate: '10/15/2023 10:00',
        plannedEndDate: '10/16/2023 10:00',
        actualEndDate: '10/16/2023 10:00',
        priority: 'Низкий',
        id: '335785a7-f734-4e15-9d57-db353037cb8e'
      },
      {
        description: '',

        tasklName: 'Наряд 155',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 155',
        department: {
          label: 'Фил Краснодарск',
          key: '144b9bc9-fee0-4618-a5d6-4383cf565b84'
        },
        employees: [
          {
            fullName: 'Исполнитель 76',
            id: '8d910c51-dc00-410e-9eb7-bc9076aa865e'
          }
        ],
        actualStartDate: '10/16/2023 10:00',
        plannedEndDate: '10/17/2023 10:00',
        actualEndDate: '10/17/2023 10:00',
        priority: 'Средний',
        id: '12644857-3a1d-4129-9ae5-494904249aa4'
      },
      {
        description: '',

        tasklName: 'Наряд 156',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 156',
        department: {
          label: 'Фил Сев-Осетинск',
          key: '5cac7dc5-c9d9-404e-be1e-8d1a36371da7'
        },
        employees: [
          {
            fullName: 'Исполнитель 77',
            id: 'f9f951b2-7361-4d3b-ab44-3e0d0fbeeec4'
          }
        ],
        actualStartDate: '10/17/2023 10:00',
        plannedEndDate: '10/18/2023 10:00',
        actualEndDate: '10/18/2023 10:00',
        priority: 'Высокий',
        id: 'cdff4a56-922a-4650-a88e-5e2fb6f6327f'
      },
      {
        description: '',

        tasklName: 'Наряд 157',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 157',
        department: {
          label: 'Фил Волгоградск',
          key: '31db859f-0297-4ba0-ac3d-42a133222fe9'
        },
        employees: [
          {
            fullName: 'Исполнитель 78',
            id: 'db103b7d-2125-4d13-8cda-c9256ea7316d'
          }
        ],
        actualStartDate: '10/18/2023 10:00',
        plannedEndDate: '10/19/2023 10:00',
        actualEndDate: '10/19/2023 10:00',
        priority: 'Низкий',
        id: '518f68e3-ddbc-4fc0-a74b-b102f24f5f8c'
      },
      {
        description: '',

        tasklName: 'Наряд 158',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 158',
        department: {
          label: 'Фил Ростовский',
          key: '437187b9-d24f-4d3e-b744-69ae49370c4d'
        },
        employees: [
          {
            fullName: 'Исполнитель 79',
            id: '800ae1e9-4f64-4b6e-ba13-b55d9b2ac633'
          }
        ],
        actualStartDate: '10/19/2023 10:00',
        plannedEndDate: '10/20/2023 10:00',
        actualEndDate: '10/20/2023 10:00',
        priority: 'Средний',
        id: '0a592976-f1b2-489e-9121-56fef4596a3e'
      },
      {
        description: '',

        tasklName: 'Наряд 159',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 159',
        department: {
          label: 'ДРОС Юг',
          key: 'c5ba17e7-613d-4403-80d1-3d978e2b2cf0'
        },
        employees: [
          {
            fullName: 'Исполнитель 80',
            id: '3b0c597a-fba2-4956-97ca-1034545ebce2'
          }
        ],
        actualStartDate: '10/20/2023 10:00',
        plannedEndDate: '10/21/2023 10:00',
        actualEndDate: '10/21/2023 10:00',
        priority: 'Высокий',
        id: '3f443d19-7e49-4c8b-8637-1a407b18deda'
      },
      {
        description: '',

        tasklName: 'Наряд 160',
        taskType: 'Тип наряда 1',
        taskStatus: 'Статус 1',
        object: 'Объект 160',
        department: {
          label: 'ГУТС (МРФ ЮГ)',
          key: 'ee2354c4-85af-4561-aab3-b10b514e5d15'
        },
        employees: [
          {
            fullName: 'Исполнитель 81',
            id: 'd446237c-b473-4440-89d0-000be7b1c028'
          }
        ],
        actualStartDate: '10/21/2023 10:00',
        plannedEndDate: '10/22/2023 10:00',
        actualEndDate: '10/22/2023 10:00',
        priority: 'Низкий',
        id: 'd6a6ae67-f5c9-40f7-adf3-f20a4371a551'
      },
      {
        description: '',

        tasklName: 'Наряд 161',
        taskType: 'Тип наряда 2',
        taskStatus: 'Статус 2',
        object: 'Объект 161',
        department: {
          label: 'ОМСС',
          key: '2f8fa0de-d277-49b6-adce-b6fbaeaea6e8'
        },
        employees: [
          {
            fullName: 'Исполнитель 82',
            id: '37c54b5a-854c-4ae1-86f5-6d1b02d17690'
          }
        ],
        actualStartDate: '10/22/2023 10:00',
        plannedEndDate: '10/23/2023 10:00',
        actualEndDate: '10/23/2023 10:00',
        priority: 'Средний',
        id: '7dc54766-aea5-4eef-ade5-b35d6ff6982e'
      },
      {
        description: '',

        tasklName: 'Наряд 162',
        taskType: 'Тип наряда 3',
        taskStatus: 'Статус 3',
        object: 'Объект 162',
        department: {
          label: 'Фил Ингушский',
          key: 'b03d0fa4-69c1-45cc-bb7f-6a671a1ad6ef'
        },
        employees: [
          {
            fullName: 'Исполнитель 83',
            id: '97f136ad-5721-4194-a3b9-01f1027e3570'
          }
        ],
        actualStartDate: '10/23/2023 10:00',
        plannedEndDate: '10/23/2023 17:00',
        actualEndDate: '10/23/2023 17:00',
        priority: 'Высокий',
        id: '3be3b2e8-2c61-4f2e-868d-d5892d48c454'
      }
    ];
  },

  getTasks() {
    return Promise.resolve(this.getData());
  }
};
